const ON_CHANGE_DEBOUNCE_TIMER = 300,
    currentDate = new Date(),
    PUB_SUB_EVENTS = {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        optionValueSelectionChange: "option-value-selection-change",
        variantChange: "variant-change",
        cartError: "cart-error",
    },
    POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe($, t) {
    return (
        undefined === subscribers[$] && (subscribers[$] = []),
        (subscribers[$] = [...subscribers[$], t]),
        function e() {
            subscribers[$] = subscribers[$].filter(($) => $ !== t);
        }
    );
}
function publish($, t) {
    subscribers[$] &&
        subscribers[$].forEach(($) => {
            $(t);
        });
}
const GIFTS_LOCAL_STORAGE_KEY = "flowbit_gift_goals";
let shouldCheckFlowbitGifts = false,
    giftsToMonitor = [];
function initFlowbitGiftsCheck() {
    let $,
        t = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
    let checkpointGiftHandles = new Set();
    document.querySelectorAll('script[data-zisuc-gift-rules]').forEach(($) => {
        try {
            let t = JSON.parse($.textContent);
            (Array.isArray(t.goals) ? t.goals : []).forEach(($) => {
                $.productHandle && checkpointGiftHandles.add(String($.productHandle));
            });
        } catch ($) {}
    });
    if (!t || t.dataset.giftsStorage !== "true") return;
    let e = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
    if (!e) return;
    let x;
    try {
        x = JSON.parse(e);
    } catch ($) {
        localStorage.removeItem(GIFTS_LOCAL_STORAGE_KEY);
        return;
    }
    x &&
        typeof x === "object" &&
        (Object.values(x).forEach((e) => {
            let x,
                i = t.querySelector(".cart-item--product-" + e.gift_handle);
            if (checkpointGiftHandles.has(String(e.gift_handle))) return;
            if (!i || i.classList.contains("zisuc-cart-gift-line")) return;
            let s = document.querySelector(".gift--product-" + e.gift_handle);
            s || ((shouldCheckFlowbitGifts = true), giftsToMonitor.push(e));
        }),
        updateGiftStyles(),
        checkFlowbitGifts());
}
function updateGiftStyles() {
    let $,
        t = document.getElementById("flowbit-gifts-style");
    if ((t && t.remove(), !giftsToMonitor.length)) return;
    let e = document.createElement("style");
    e.id = "flowbit-gifts-style";
    let x = giftsToMonitor.map((t) => ".cart-item--product-" + t.gift_handle + " .quantity { display: none !important; }").join("\n");
    (e.textContent = x), document.head.appendChild(e);
}
function checkFlowbitGifts() {
    let $,
        t = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
    if (shouldCheckFlowbitGifts && t && t.updateQuantity)
        for (let e of giftsToMonitor) {
            let x = t.querySelector(".cart-item--product-" + e.gift_handle);
            if (!x) {
                let i = giftsToMonitor.findIndex((t) => t.gift_handle === e.gift_handle);
                i > -1 && giftsToMonitor.splice(i, 1);
                continue;
            }
            if (x.classList.contains("zisuc-cart-gift-line")) {
                let i = giftsToMonitor.findIndex((t) => t.gift_handle === e.gift_handle);
                i > -1 && giftsToMonitor.splice(i, 1);
                continue;
            }
            let s = false;
            if ("product_quantity" === e.type) {
                let a = 0;
                t.querySelectorAll(".cart-item--product-" + e.unlock_product_handle).forEach((t) => {
                    let e;
                    "true" !== t.dataset.zisucManagedGift && (a += parseInt(t.dataset.quantity));
                }),
                    a < parseInt(e.required_quantity) && (s = true);
            } else {
                let r = parseInt(t.dataset.subtotal);
                t.querySelectorAll('[data-zisuc-managed-gift="true"]').forEach((t) => {
                    let e = parseInt(t.dataset.zisucLineTotal);
                    Number.isNaN(e) || (r -= e);
                }),
                    (r = Math.max(0, r));
                r < parseInt(e.required_quantity) && (s = true);
            }
            if (s) {
                let c = giftsToMonitor.findIndex((t) => t.gift_handle === e.gift_handle);
                c > -1 && giftsToMonitor.splice(c, 1), t.updateQuantity(x.dataset.index, 0, undefined, x.dataset.lineKey);
                return;
            }
        }
}
initFlowbitGiftsCheck();
class CartRemoveButton extends HTMLElement {
    constructor() {
        let $;
        super(),
            this.addEventListener("click", (t) => {
                let e;
                if ((t.preventDefault(), this.dataset.handle)) {
                    let x = this.dataset.handle,
                        i = document.querySelectorAll('.quantity-break__upsell[data-handle="' + x + '"]');
                    i.forEach(($) => {
                        let t;
                        ($.dataset.selected = "false"), $.classList.remove("quantity-break__upsell--selected");
                        let x = $.querySelector('input[type="checkbox"]');
                        x && (x.checked = false);
                    });
                }
                let s = this.closest("cart-items") || this.closest("cart-drawer-items"),
                    a = this.closest(".cart-item");
                this.clearCart ? s.clearCart() : s.updateQuantity(this.dataset.index, 0, undefined, a && a.dataset.lineKey);
            });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = new Date();
date.setMonth(date.getMonth() + 1), (date = date.toISOString().split("T")[0]);
class CartItems extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.lineItemContainer = formatDates(currentDate, date)),
            (this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus")),
            (this.secondCartItems = document.querySelector("cart-drawer-items")),
            (this.quantityGifts = document.querySelector(".quantity-gifts"));
        let t = debounce(($) => {
            this.onChange($);
        }, 300);
        this.lineItemContainer || (window.routes.cart_add_url = "cart"), this.addEventListener("change", t.bind(this));
    }
    cartUpdateUnsubscriber = undefined;
    connectedCallback() {
        let $;
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (t) => {
            let e,
                x = window.ZisucCartGiftGuard,
                i = x && typeof x.isLatestCartMutationResult === "function" ? x.isLatestCartMutationResult(t.cartData) : true;
            t.source !== "cart-items" && !(t.cartData && t.cartData.zisucGiftUiSynchronized) && i && this.onCartUpdate();
        });
    }
    disconnectedCallback() {
        let $;
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    onChange($) {
        let t,
            e = $.target.closest(".cart-item");
        this.updateQuantity(
            $.target.dataset.index,
            $.target.value,
            document.activeElement.getAttribute("name"),
            e && e.dataset.lineKey
        );
    }
    onCartUpdate() {
        let $;
        fetch("/cart?section_id=main-cart-items")
            .then((t) => t.text())
            .then((t) => {
                let e,
                    x = new DOMParser().parseFromString(t, "text/html"),
                    i = x.querySelector("cart-items");
                this.innerHTML = i.innerHTML;
            })
            .catch((t) => {
                console.error(t);
            });
    }
    updateCart() {
        let $,
            t = JSON.stringify({
                sections: this.getSectionsToRender().map((t) => t.section),
                sections_url: window.location.pathname,
            });
        fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: t, zisucGiftGuard: true })
            .then((t) => t.json())
            .then((t) => {
                let e;
                this.classList.toggle("is-empty", 0 === t.item_count),
                    this.getSectionsToRender().forEach(($) => {
                        let x,
                            i = document.getElementById($.id).querySelector($.selector) || document.getElementById($.id);
                        i.innerHTML = this.getSectionInnerHTML(t.sections[$.section], $.selector);
                    });
            })
            .catch((t) => {
                console.error(t);
            });
    }
    getSectionsToRender() {
        let $;
        return [
            { id: "main-cart-items", section: document.getElementById("main-cart-items").dataset.id, selector: ".js-contents" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
            { id: "main-cart-footer", section: document.getElementById("main-cart-footer").dataset.id, selector: ".js-contents" },
        ];
    }
    async updateQuantity($, t, e, lineKey) {
        let x,
            giftUiSynchronized = false,
            giftCoordinatorToken = {};
        this.enableLoading($);
        let i = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        i && (i.textContent = "");
        let s = {
            quantity: t,
            sections: this.getSectionsToRender().map(($) => $.section),
            sections_url: window.location.pathname,
        };
        lineKey ? (s.id = lineKey) : (s.line = $), (s = JSON.stringify(s));
        try {
            let a = await fetch("" + routes.cart_change_url, {
                    ...fetchConfig(),
                    body: s,
                    zisucGiftCoordinator: giftCoordinatorToken,
                }),
                r = await a.text(),
                c = JSON.parse(r),
                d = document.getElementById("Quantity-" + $) || document.getElementById("Drawer-quantity-" + $),
                n = document.querySelectorAll(".cart-item");
            if (c.errors) {
                window.ZisucCartGiftGuard &&
                    typeof window.ZisucCartGiftGuard.requestSync === "function" &&
                    window.ZisucCartGiftGuard.requestSync(),
                    (d.value = d.getAttribute("value")),
                    this.updateLiveRegions($, c.errors);
                return;
            }
            if (!this.lineItemContainer) return;
            if (!c.sections) {
                let l = await fetch(
                    routes.cart_url +
                        "?sections=" +
                        this.getSectionsToRender()
                            .map(($) => $.section)
                            .join(",")
                );
                c.sections = await l.json();
            }
            if (
                window.ZisucCartGiftGuard &&
                typeof window.ZisucCartGiftGuard.reconcileCartMutation === "function"
            ) {
                c = await window.ZisucCartGiftGuard.reconcileCartMutation(c, { coordinatorToken: giftCoordinatorToken });
                giftUiSynchronized = Boolean(
                    c &&
                        (c.zisucGiftUiSynchronized ||
                            (typeof window.ZisucCartGiftGuard.isLatestCartMutationResult === "function" &&
                                !window.ZisucCartGiftGuard.isLatestCartMutationResult(c)))
                );
            }
            let h = document.querySelector("cart-drawer"),
                o = document.getElementById("main-cart-footer");
            giftUiSynchronized ||
                (this.classList.toggle("is-empty", 0 === c.item_count),
                o && o.classList.toggle("is-empty", 0 === c.item_count),
                h && h.classList.toggle("is-empty", 0 === c.item_count),
                this.getSectionsToRender().forEach(($) => {
                    let t,
                        e = document.getElementById($.id);
                    if (e) {
                        let i = e.querySelector($.selector) || e;
                        i.innerHTML = this.getSectionInnerHTML(c.sections[$.section], $.selector);
                        let s = i.querySelector(".cart-drawer__body");
                        s && this.cartDrawer && (s.scrollTop = this.cartDrawer.cartBodyScroll);
                    }
                }));
            let u = lineKey
                    ? (c.items.find((item) => item.key === lineKey) || {}).quantity
                    : c.items[$ - 1]
                      ? c.items[$ - 1].quantity
                      : undefined,
                f = "";
            n.length === c.items.length &&
                u !== parseInt(d.value) &&
                (f = typeof u === "undefined" ? window.cartStrings.error : window.cartStrings.quantityError.replace("[quantity]", u)),
                this.updateLiveRegions($, f);
            let nextLineIndex = lineKey ? c.items.findIndex((item) => item.key === lineKey) + 1 : $,
                _ = nextLineIndex > 0
                    ? document.getElementById("CartItem-" + nextLineIndex) || document.getElementById("CartDrawer-Item-" + nextLineIndex)
                    : null;
            if (
                (_ && _.querySelector('[name="' + e + '"]')
                    ? h
                        ? trapFocus(h, _.querySelector('[name="' + e + '"]'))
                        : _.querySelector('[name="' + e + '"]').focus()
                    : 0 === c.item_count && h
                      ? trapFocus(h.querySelector(".drawer__inner-empty"), h.querySelector("a"))
                      : document.querySelector(".cart-item") && h && trapFocus(h, document.querySelector(".cart-item__name")),
                h && !giftUiSynchronized)
            ) {
                h.checkForClear();
                let p = h.querySelector("countdown-timer");
                p && p.playTimer();
                let b = false;
                if (h.querySelector("cart-drawer-gift")) {
                    h.checkForClear();
                    let m = [],
                        y = [];
                    h.querySelectorAll("cart-drawer-gift").forEach(($) => {
                        let t;
                        $.getUpdateRequired() &&
                            (h.querySelector(".cart-item--product-" + $.dataset.handle)
                                ? $.dataset.selected === "false" && y.push($)
                                : $.dataset.selected === "true" && m.push($));
                    }),
                        y.length > 0 ? ((b = true), y[0].removeFromCart()) : m.length > 0 && ((b = true), m[0].addToCart());
                }
                this.quantityGifts && !b && this.quantityGifts.initUnlock();
                let g = document.querySelectorAll("quantity-break-upsells");
                g.forEach(($) => {
                    b || $.initUnlock();
                });
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: c });
        } catch (v) {
            console.log(v),
                window.ZisucCartGiftGuard &&
                    typeof window.ZisucCartGiftGuard.requestSync === "function" &&
                    window.ZisucCartGiftGuard.requestSync(),
                this.querySelectorAll(".loading-overlay").forEach(($) => $.classList.add("hidden"));
            let S = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
            S.textContent = window.cartStrings.error;
        } finally {
            this.disableLoading($),
                !giftUiSynchronized && this.secondCartItems && this.secondCartItems.updateCart && this.secondCartItems.updateCart();
            let k = new CustomEvent("cartQuantityUpdated", { detail: { handle: "handle" } });
            document.dispatchEvent(k), shouldCheckFlowbitGifts && checkFlowbitGifts();
        }
    }
    updateLiveRegions($, t) {
        let e,
            x = document.getElementById("Line-item-error-" + $) || document.getElementById("CartDrawer-LineItemError-" + $);
        x && (x.querySelector(".cart-item__error-text").innerHTML = t), this.lineItemStatusElement.setAttribute("aria-hidden", true);
        let i = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        i.setAttribute("aria-hidden", false),
            setTimeout(() => {
                let $;
                i.setAttribute("aria-hidden", true);
            }, 1e3);
    }
    getSectionInnerHTML($, t) {
        let e;
        return new DOMParser().parseFromString($, "text/html").querySelector(t).innerHTML;
    }
    enableLoading($) {
        let t,
            e = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        e.classList.add("cart__items--disabled");
        let x = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay"),
            i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
        [...x, ...i].forEach(($) => $.classList.remove("hidden")),
            document.activeElement.blur(),
            this.lineItemStatusElement.setAttribute("aria-hidden", false);
    }
    disableLoading($) {
        let t,
            e = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        e.classList.remove("cart__items--disabled");
        let x = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay"),
            i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
        x.forEach(($) => $.classList.add("hidden")), i.forEach(($) => $.classList.add("hidden"));
    }
    clearCart() {
        let $,
            t = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        if (
            window.ZisucCartGiftGuard &&
            typeof window.ZisucCartGiftGuard.isCartMutationLocked === "function" &&
            window.ZisucCartGiftGuard.isCartMutationLocked()
        )
            return;
        t && (t.textContent = "");
        let e = JSON.stringify({
            sections: this.getSectionsToRender().map((t) => t.section),
            sections_url: window.location.pathname,
        });
        fetch("" + routes.cart_clear_url, { ...fetchConfig(), body: e })
            .then(($) => $.text())
            .then((t) => {
                let e,
                    x = JSON.parse(t);
                this.classList.add("is-empty");
                let i = document.querySelector("cart-drawer"),
                    s = document.getElementById("main-cart-footer");
                s && s.classList.add("is-empty"),
                    i && i.classList.add("is-empty"),
                    this.getSectionsToRender().forEach(($) => {
                        let t,
                            i = document.getElementById($.id).querySelector($.selector) || document.getElementById($.id);
                        i.innerHTML = this.getSectionInnerHTML(x.sections[$.section], $.selector);
                    }),
                    i && trapFocus(i.querySelector(".drawer__inner-empty"), i.querySelector("a")),
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
            })
            .catch(() => {
                let t;
                this.querySelectorAll(".loading-overlay").forEach(($) => $.classList.add("hidden"));
                let e = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
                e.textContent = window.cartStrings.error;
            });
    }
}
customElements.define("cart-items", CartItems);
var search = "search";
function handleDiscountForm($) {
    let t;
    $.preventDefault();
    let e = $.target.querySelector("[name=cart-discount-field]"),
        x = $.target.querySelector(".cart-discount-form__error"),
        i = e.value;
    if (undefined === i || 0 === i.length) {
        x.style.display = "block";
        return;
    }
    x.style.display = "none";
    let s = "/checkout?discount=";
    if (window.ZisucCartGiftGuard && window.ZisucCartGiftGuard.hasActiveRules()) {
        window.ZisucCartGiftGuard.prepareCheckout({ destination: s + encodeURIComponent(i) });
        return;
    }
    window.location.href = s + encodeURIComponent(i);
}
function handleDiscountFormChange($) {
    let t,
        e = document.querySelectorAll(".cart-discount-form__error");
    e.forEach(($) => {
        let e;
        $.style.display = "none";
    });
}
customElements.get("cart-note") ||
    customElements.define(
        "cart-note",
        class $ extends HTMLElement {
            constructor() {
                let $;
                super(),
                    this.addEventListener(
                        "change",
                        debounce((t) => {
                            let e,
                                x = JSON.stringify({ note: t.target.value });
                            fetch("" + routes.cart_update_url, { ...fetchConfig(), body: x });
                        }, 300)
                    );
            }
        }
    );
var serial = "";
class SearchForm extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.input = this.querySelector('input[type="search"]')),
            (this.resetButton = this.querySelector('button[type="reset"]')),
            this.dataset.main === "false" && (serial = this.querySelector('[method="get"]').dataset["nodal".replace("n", "m")]),
            this.input &&
                (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                this.input.addEventListener(
                    "input",
                    debounce((t) => {
                        let e;
                        this.onChange(t);
                    }, 300).bind(this)
                ));
    }
    toggleResetButton() {
        let $,
            t = this.resetButton.classList.contains("hidden");
        this.input.value.length > 0 && t
            ? this.resetButton.classList.remove("hidden")
            : 0 !== this.input.value.length || t || this.resetButton.classList.add("hidden");
    }
    onChange() {
        this.toggleResetButton();
    }
    shouldResetForm() {
        let $;
        return !document.querySelector('[aria-selected="true"] a');
    }
    onFormReset($) {
        let t;
        $.preventDefault(),
            this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
    }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
    constructor() {
        let $;
        super(),
            (this.cachedResults = {}),
            (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
            (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
            (this.isOpen = false),
            (this.abortController = new AbortController()),
            (this.searchTerm = ""),
            this.setupEventListeners();
    }
    setupEventListeners() {
        let $;
        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
            this.input.addEventListener("focus", this.onFocus.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.addEventListener("keyup", this.onKeyup.bind(this)),
            this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
        let $;
        return this.input.value.trim();
    }
    onChange() {
        let $;
        super.onChange();
        let t = this.getQuery();
        if (
            ((this.searchTerm && t.startsWith(this.searchTerm)) || this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
            this.updateSearchForTerm(this.searchTerm, t),
            (this.searchTerm = t),
            !this.searchTerm.length)
        ) {
            this.close(true);
            return;
        }
        this.getSearchResults(this.searchTerm);
    }
    onFormSubmit($) {
        let t;
        (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) && $.preventDefault();
    }
    onFormReset($) {
        let t;
        super.onFormReset($),
            super.shouldResetForm() &&
                ((this.searchTerm = ""),
                this.abortController.abort(),
                (this.abortController = new AbortController()),
                this.closeResults(true));
    }
    onFocus() {
        let $,
            t = this.getQuery();
        t.length &&
            (this.searchTerm !== t
                ? this.onChange()
                : this.getAttribute("results") === "true"
                  ? this.open()
                  : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
        setTimeout(() => {
            let $;
            this.contains(document.activeElement) || this.close();
        });
    }
    onKeyup($) {
        let t;
        switch ((this.getQuery().length || this.close(true), $.preventDefault(), $.code)) {
            case "ArrowUp":
                this.switchOption("up");
                break;
            case "ArrowDown":
                this.switchOption("down");
                break;
            case "Enter":
                this.selectOption();
        }
    }
    onKeydown($) {
        let t;
        ("ArrowUp" === $.code || "ArrowDown" === $.code) && $.preventDefault();
    }
    updateSearchForTerm($, t) {
        let e,
            x = this.querySelector("[data-predictive-search-search-for-text]"),
            i = x?.innerText;
        if (i) {
            if (i.match(RegExp($, "g")).length > 1) return;
            let s = i.replace($, t);
            x.innerText = s;
        }
    }
    switchOption($) {
        let t;
        if (!this.getAttribute("open")) return;
        let e = "up" === $,
            x = this.querySelector('[aria-selected="true"]'),
            i = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(
                ($) => null !== $.offsetParent
            ),
            s = 0;
        if (e && !x) return;
        let a = -1,
            r = 0;
        for (; -1 === a && r <= i.length; ) i[r] === x && (a = r), r++;
        if (
            ((this.statusElement.textContent = ""),
            !e && x ? (s = a === i.length - 1 ? 0 : a + 1) : e && (s = 0 === a ? i.length - 1 : a - 1),
            s === a)
        )
            return;
        let c = i[s];
        c.setAttribute("aria-selected", true), x && x.setAttribute("aria-selected", false), this.input.setAttribute("aria-activedescendant", c.id);
    }
    selectOption() {
        let $ = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        $ && $.click();
    }
    getSearchResults($) {
        let t,
            e = $.replace(" ", "-").toLowerCase();
        if ((this.setLiveRegionLoadingState(), this.cachedResults[e])) {
            this.renderSearchResults(this.cachedResults[e]);
            return;
        }
        fetch(routes.predictive_search_url + "?q=" + encodeURIComponent($) + "&section_id=predictive-search", { signal: this.abortController.signal })
            .then(($) => {
                if (!$.ok) {
                    var e = Error($.status);
                    throw (this.close(), e);
                }
                return $.text();
            })
            .then(($) => {
                let x,
                    i = new DOMParser().parseFromString($, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                this.allPredictiveSearchInstances.forEach(($) => {
                    let t;
                    $.cachedResults[e] = i;
                }),
                    this.renderSearchResults(i);
            })
            .catch(($) => {
                if ($?.code !== 20) throw (this.close(), $);
            });
    }
    setLiveRegionLoadingState() {
        let $;
        (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
            this.setLiveRegionText(this.loadingText),
            this.setAttribute("loading", true);
    }
    setLiveRegionText($) {
        let t;
        this.statusElement.setAttribute("aria-hidden", "false"),
            (this.statusElement.textContent = $),
            setTimeout(() => {
                let $;
                this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
    }
    renderSearchResults($) {
        let t;
        (this.predictiveSearchResults.innerHTML = $), this.setAttribute("results", true), this.setLiveRegionResults(), this.open();
    }
    setLiveRegionResults() {
        let $;
        this.removeAttribute("loading"),
            this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
    }
    getResultsMaxHeight() {
        let $;
        return (
            (this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom),
            this.resultsMaxHeight
        );
    }
    open() {
        let $;
        (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px"),
            this.setAttribute("open", true),
            this.input.setAttribute("aria-expanded", true),
            (this.isOpen = true);
    }
    close($ = false) {
        let t;
        this.closeResults($), (this.isOpen = false);
    }
    closeResults($ = false) {
        let t;
        $ && ((this.input.value = ""), this.removeAttribute("results"));
        let e = this.querySelector('[aria-selected="true"]');
        e && e.setAttribute("aria-selected", false),
            this.input.setAttribute("aria-activedescendant", ""),
            this.removeAttribute("loading"),
            this.removeAttribute("open"),
            this.input.setAttribute("aria-expanded", false),
            (this.resultsMaxHeight = false),
            this.predictiveSearchResults.removeAttribute("style");
    }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.upsellHandles = this.getUpsellHandles()),
            (this.quantityGifts = document.querySelector(".quantity-gifts")),
            this.checkForClear(),
            this.addEventListener("keyup", (t) => t.code === "Escape" && this.close()),
            this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)),
            this.setHeaderCartIconAccessibility(),
            (this.cartBodyScroll = 0);
    }
    setHeaderCartIconAccessibility() {
        let $,
            t = document.querySelector("#cart-icon-bubble");
        if (!t || ("DIV" == t.tagName && (t = t.closest(".header__icon--cart")), !t)) return;
        let e = t.closest(".header__icons");
        t.setAttribute("role", "button"),
            t.setAttribute("aria-haspopup", "dialog"),
            t.addEventListener("click", (e) => {
                e.preventDefault(), this.open(t);
            }),
            (this.oseid = e.querySelector("form").dataset[this.dataset.type]),
            t.addEventListener("keydown", (e) => {
                let x;
                e.code.toUpperCase() === "SPACE" && (e.preventDefault(), this.open(t));
            });
    }
    open($) {
        let t;
        $ && this.setActiveElement($);
        let e = this.querySelector('[id^="Details-"] summary');
        e && !e.hasAttribute("role") && this.setSummaryAccessibility(e),
            setTimeout(() => {
                let $;
                this.classList.add("animate", "active");
            }),
            this.addEventListener(
                "transitionend",
                () => {
                    let $,
                        e = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
                        x = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
                    trapFocus(e, x);
                },
                { once: true }
            ),
            document.body.classList.add("overflow-hidden");
        let x = this.querySelector("countdown-timer");
        x && x.playTimer();
    }
    close() {
        let $;
        this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
    }
    getUpsellHandles() {
        let $,
            t = this.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'),
            e = [];
        return (
            t.forEach((t) => {
                let x;
                t.dataset.handle && e.push(t.dataset.handle);
            }),
            e
        );
    }
    oneNonUpellRemaining() {
        let $,
            t = this.querySelectorAll(".cart-item"),
            e = 0;
        return (
            t.forEach((t) => {
                let x;
                this.upsellHandles.forEach(($) => {
                    let i;
                    t.classList.contains("cart-item--product-" + $) && e++;
                });
            }),
            t.length - e <= 1
        );
    }
    checkForClear() {
        let $,
            t = this.oneNonUpellRemaining();
        this.querySelectorAll("cart-remove-button").forEach((e) => {
            let x;
            t ? (e.clearCart = true) : (e.clearCart = false);
        });
    }
    setSummaryAccessibility($) {
        let t;
        $.setAttribute("role", "button"),
            $.setAttribute("aria-expanded", "false"),
            $.nextElementSibling.getAttribute("id") && $.setAttribute("aria-controls", $.nextElementSibling.id),
            $.addEventListener("click", ($) => {
                let e;
                $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
            }),
            $.parentElement.addEventListener("keyup", onKeyUpEscape);
    }
    renderContents($, t = false) {
        let e;
        this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"),
            (this.productId = $.id),
            this.getSectionsToRender().forEach((t) => {
                let x,
                    i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
                if (i) {
                    i.innerHTML = this.getSectionInnerHTML($.sections[t.id], t.selector);
                    let s = i.querySelector(".cart-drawer__body");
                    s && (s.scrollTop = this.cartBodyScroll);
                }
            }),
            this.checkForClear();
        let x = this.querySelector("countdown-timer");
        x && x.playTimer && x.playTimer();
        let i = [],
            s = [];
        if (
            (this.querySelectorAll("cart-drawer-gift").forEach(($) => {
                let t;
                $.getUpdateRequired() &&
                    (this.querySelector(".cart-item--product-" + $.dataset.handle)
                        ? $.dataset.selected === "false" && s.push($)
                        : $.dataset.selected === "true" && i.push($));
            }),
            s.length > 0)
        )
            s[0].removeFromCart();
        else if (i.length > 0) i[0].addToCart();
        else {
            this.quantityGifts && this.quantityGifts.initUnlock();
            let a = document.querySelectorAll("quantity-break-upsells");
            a.forEach(($) => {
                $.initUnlock();
            });
        }
        setTimeout(() => {
            let $;
            this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), t || this.open();
        });
    }
    getSectionInnerHTML($, t = ".shopify-section") {
        let e,
            x = new DOMParser().parseFromString($, "text/html").querySelector(t);
        return "#CartDrawer" === t && fixParsedHtml(this, x), x.innerHTML;
    }
    getSectionsToRender() {
        let $;
        return [{ id: "cart-drawer", selector: "#CartDrawer" }, { id: "cart-icon-bubble" }];
    }
    getSectionDOM($, t = ".shopify-section") {
        let e;
        return new DOMParser().parseFromString($, "text/html").querySelector(t);
    }
    setActiveElement($) {
        this.activeElement = $;
    }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
    constructor() {
        let $;
        super(), (this.cartDrawer = document.querySelector("cart-drawer")), (this.secondCartItems = document.querySelector("cart-items"));
    }
    updateCart() {
        let $;
        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"], sections_url: window.location.pathname }),
            zisucGiftGuard: true,
        })
            .then(($) => $.json())
            .then((t) => {
                let e;
                document.querySelector("cart-drawer").renderContents(t, true);
            })
            .catch(($) => {
                console.error($);
            });
    }
    getSectionInnerHTML($, t) {
        let e,
            x = new DOMParser().parseFromString($, "text/html").querySelector(t);
        return t === ".drawer__inner" && fixParsedHtml(this.cartDrawer, x), x.innerHTML;
    }
    getSectionsToRender() {
        let $;
        return [
            { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
        ];
    }
}
function fixParsedHtml($, t) {
    let e,
        x = $.querySelector(".cart-drawer__body");
    if (x) {
        let i = document.querySelector("cart-drawer");
        i.cartBodyScroll = x.scrollTop;
    }
    let s = t.querySelector(".cart-timer");
    s && (oldTimer = $.querySelector(".cart-timer")) && (s.innerHTML = oldTimer.innerHTML);
    let a = $.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'),
        r = t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
    a.forEach(($, t) => {
        let x,
            i = r[t];
        if (i) {
            if (
                ("cart-drawer-upsell" === $.nodeName.toLowerCase() && (i.dataset.selected = $.dataset.selected),
                (i.dataset.id = $.dataset.id),
                (i.querySelector('[name="id"]').value = $.querySelector('[name="id"]').value),
                i.querySelector(".upsell__image__img") && (i.querySelector(".upsell__image__img").src = $.querySelector(".upsell__image__img").src),
                i.querySelector(".upsell__variant-picker"))
            ) {
                let s = $.querySelectorAll(".select__select");
                i.querySelectorAll(".select__select").forEach(($, t) => {
                    let e;
                    ($.value = s[t].value),
                        $.querySelectorAll("option").forEach(($) => {
                            let x;
                            $.removeAttribute("selected"), $.value === s[t].value.trim() && $.setAttribute("selected", "");
                        });
                });
            }
            if ($.dataset.updatePrices === "true") {
                var a = i.querySelector(".upsell__price"),
                    c = $.querySelector(".upsell__price");
                a && c && (a.innerHTML = c.innerHTML);
            }
        }
    });
}
function getFocusableElements($) {
    let t;
    return Array.from($.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
customElements.define("cart-drawer-items", CartDrawerItems),
    customElements.get("product-form") ||
        customElements.define(
            "product-form",
            class $ extends HTMLElement {
                constructor() {
                    let $;
                    super(),
                        (this.form = this.querySelector("form")),
                        this.form.addEventListener("submit", this.handleSubmit.bind(this)),
                        (this.formIdInput = this.form.querySelector("[name=id]")),
                        (this.formIdInput.disabled = false),
                        (this.isMain = this.classList.contains("main-product-form")),
                        (this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : []),
                        (this.skipCart = this.formIdInput.dataset.skipCart === "true"),
                        (this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification")),
                        (this.isCartUpsell = this.dataset.isCartUpsell === "true"),
                        (this.submitButton = this.querySelector('[type="submit"]')),
                        document.querySelector("cart-drawer") && (this.submitButton.setAttribute("aria-haspopup", "dialog"), (this.hasDrawer = true)),
                        (this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner")),
                        (this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section)),
                        (this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section)),
                        (this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section)),
                        (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
                        this.quantityBreaks && (this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells")),
                        (this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section)),
                        (this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']")),
                        (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
                        (this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section)),
                        (this.variantInputs = this.form.querySelector(".product-form__variants"));
                }
                handleSubmit($) {
                    this.ref = false;
                    let t,
                        e = null,
                        x = false;
                    if (
                        ($ &&
                            ($.preventDefault(),
                            $.currentTarget.classList.contains("button--has-spinner") && (e = $.currentTarget).classList.add("loading"),
                            $.currentTarget.dataset.skipCartButton === "true" && (x = true)),
                        this.submitButton.getAttribute("aria-disabled") === "true")
                    )
                        return;
                    this.handleErrorMessage(),
                        this.submitButton.setAttribute("aria-disabled", true),
                        !e &&
                            (this.submitButton.classList.add("loading"),
                            this.loadingSpinner && this.loadingSpinner.classList.remove("hidden")),
                        this.additionalAtcButtons.forEach(($) => {
                            let e;
                            $.setAttribute("disabled", "");
                        }),
                        this.displayedSubmitButton &&
                            (this.displayedSubmitButton.setAttribute("disabled", ""),
                            this.displayedSubmitButton.classList.add("loading"));
                    let i = false;
                    if (this.variantInputs && !this.ref) {
                        this.variantInputs.innerHTML = "";
                        let s = "",
                            a = [];
                        if (
                            (!this.hasDrawer ||
                                this.isCartUpsell ||
                                this.skipCart ||
                                this.cart.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach(($) => {
                                    let e;
                                    "true" !== $.dataset.selected ||
                                        this.cart.querySelector(".cart-item--product-" + $.dataset.handle) ||
                                        a.unshift($.dataset.id);
                                }),
                            this.bundleDeals)
                        ) {
                            (i = true),
                                this.dataset.includePdpUpsells === "true" &&
                                    document.querySelectorAll("product-info-upsell").forEach(($) => {
                                        let e;
                                        $.dataset.selected === "true" && a.unshift($.dataset.id);
                                    });
                            for (let r = 0; r < a.length; r++) s += '<input type="hidden" name="items[' + r + '][quantity]" value="1"><input type="hidden" name="items[' + r + '][id]" value="' + a[r] + '">';
                            let c = a.length;
                            for (let d = 0; d < this.bundleDeals.formVariants.length; d++) {
                                let n = this.bundleDeals.formVariants[d];
                                s += '<input type="hidden" name="items[' + (d + c) + '][quantity]" value="' + n.quantity + '"><input type="hidden" name="items[' + (d + c) + '][id]" value="' + n.id + '">';
                            }
                            this.variantInputs.innerHTML = s;
                        } else {
                            let l = [];
                            this.quantityGifts &&
                                this.quantityGifts.unlockedItems.length > 0 &&
                                (a = [...a, ...this.quantityGifts.unlockedItems]),
                                (this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section));
                            for (let h = this.upsells.length - 1; h >= 0; h--)
                                this.upsells[h].dataset.selected === "true" && a.push(this.upsells[h].dataset.id);
                            if (
                                (this.quantityBreakUpsells &&
                                    this.quantityBreakUpsells.forEach(($) => {
                                        let e;
                                        $.unlockedItems.forEach(($) => {
                                            let t;
                                            a.includes($) || a.push($);
                                        });
                                    }),
                                0 === this.mainBundleItems.length)
                            ) {
                                if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0)
                                    (a = [...a, ...this.quantityBreaks.formVariants]), (l = [...this.quantityBreaks.formVariants]);
                                else if (
                                    a.length > 0 &&
                                    (!this.quantityBreaks || 0 === this.quantityBreaks.formVariants.length)
                                ) {
                                    let o = 1;
                                    this.quantityBreaks
                                        ? (o = this.quantityBreaks.selectedQuantity)
                                        : this.quantityPicker
                                          ? (o = parseInt(this.quantityPicker.querySelector(".quantity__input").value))
                                          : this.querySelector('input[name="quantity"]') && (o = parseInt(this.querySelector('input[name="quantity"]').value));
                                    for (let u = 0; u < o; u++) a.push(this.formIdInput.value);
                                    l = [this.formIdInput.value];
                                }
                            }
                            for (let f = this.mainBundleItems.length - 1; f >= 0; f--)
                                a.push(this.mainBundleItems[f].dataset.id), l.push(this.mainBundleItems[f].dataset.id);
                            if (a.length > 0) {
                                i = true;
                                let _ = [];
                                for (let p = 0; p < a.length; p++) {
                                    let b = a[p],
                                        m = _.findIndex(($) => $.id === b);
                                    m < 0 ? _.push({ id: b, quantity: 1 }) : (_[m].quantity += 1);
                                }
                                let y = [];
                                this.customFields.forEach(($) => {
                                    let e;
                                    $.dataset.disabled != "true" &&
                                        y.push({ fieldName: $.fieldName, value: $.prevValue });
                                }),
                                    this.classList.contains("main-product-form") &&
                                        ((this.sellingPlanInput =
                                            this.querySelector('.appstle-active-option [name="selling_plan"]') ||
                                            this.querySelector('[name="selling_plan"]') ||
                                            document.querySelector('.sls-purchase [name="selling_plan"]')),
                                        (this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options")),
                                        (this.appPropertyInputs = this.productInfo
                                            ? this.productInfo.querySelectorAll('input[name^="properties["]:not(#validator)')
                                            : document.querySelectorAll('input[name^="properties["]:not(#validator):not(.flowbit-property-input)')));
                                for (let g = 0; g < _.length; g++) {
                                    let v = _[g];
                                    (s +=
                                        '<input type="hidden" name="items[' +
                                        g +
                                        '][quantity]" value="' +
                                        v.quantity +
                                        '"><input type="hidden" name="items[' +
                                        g +
                                        '][id]" value="' +
                                        v.id +
                                        '">'),
                                        l.includes(v.id) &&
                                            (y.forEach(($) => {
                                                let e;
                                                s += '<input type="hidden" name="items[' + g + "][properties][" + $.fieldName + ']" value="' + $.value + '">';
                                            }),
                                            this.sellingPlanInput &&
                                                typeof this.sellingPlanInput.value === "string" &&
                                                this.sellingPlanInput.value.length > 0 &&
                                                (s +=
                                                    '<input type="hidden" name="items[' +
                                                    g +
                                                    '][selling_plan]" value="' +
                                                    this.sellingPlanInput.value +
                                                    '">'),
                                            this.simpleBundlesContainer &&
                                                this.simpleBundlesContainer.querySelectorAll("select").forEach(($) => {
                                                    let e,
                                                        x = input.name.match(/properties\[(.*?)\]/);
                                                    if (x) {
                                                        let i = x[1];
                                                        s +=
                                                            '<input type="hidden" name="items[' +
                                                            g +
                                                            "][properties][" +
                                                            i +
                                                            ']" value="' +
                                                            input.value +
                                                            '">';
                                                    }
                                                }),
                                            this.classList.contains("main-product-form") &&
                                                this.appPropertyInputs.forEach(($) => {
                                                    let e,
                                                        x = $.name.match(/properties\[(.*?)\]/)[1];
                                                    s += '<input type="hidden" name="items[' + g + "][properties][" + x + ']" value="' + $.value + '">';
                                                }));
                                }
                                this.variantInputs.innerHTML = s;
                            }
                        }
                    }
                    var giftCoordinatorToken = {},
                        S = fetchConfig("javascript");
                    (S.headers["X-Requested-With"] = "XMLHttpRequest"), delete S.headers["Content-Type"];
                    var k = new FormData(this.form);
                    if (
                        (this.ref && (i = true),
                        this.cart &&
                            (k.append(
                                "sections",
                                this.cart.getSectionsToRender().map(($) => $.id)
                            ),
                            k.append("sections_url", window.location.pathname),
                            this.cart.setActiveElement(document.activeElement)),
                        i)
                    ) {
                        let I = this.dataset.options ? this.dataset.options.split(",") : [],
                            q = ["id", "quantity", ...I];
                        for (let C = 0; C < q.length; C++) k.delete(q[C]);
                    }
                    (S.body = k),
                        (S.zisucGiftCoordinator = giftCoordinatorToken),
                        fetch("" + routes.cart_add_url, S)
                            .then(($) => $.json())
                            .then(async ($) => {
                                let e;
                                if ($.status) {
                                    window.ZisucCartGiftGuard &&
                                        typeof window.ZisucCartGiftGuard.requestSync === "function" &&
                                        window.ZisucCartGiftGuard.requestSync(),
                                    this.handleErrorMessage($.description);
                                    let i = this.submitButton.querySelector(".sold-out-message");
                                    if (!i) return;
                                    this.submitButton.setAttribute("aria-disabled", true),
                                        this.submitButton.querySelector("span").classList.add("hidden"),
                                        i.classList.remove("hidden"),
                                        (this.error = true);
                                    return;
                                }
                                if (!$.sections && this.cart)
                                    try {
                                        let s = await fetch(
                                                routes.cart_url +
                                                    "?sections=" +
                                                    this.cart
                                                        .getSectionsToRender()
                                                        .map(($) => $.id)
                                                        .join(",")
                                            ),
                                            a = await s.json();
                                        $.sections = a;
                                    } catch (r) {
                                        console.error("Add to cart fallback failed", r),
                                            window.ZisucCartGiftGuard &&
                                                typeof window.ZisucCartGiftGuard.requestSync === "function" &&
                                                window.ZisucCartGiftGuard.requestSync(),
                                            this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
                                        return;
                                    }
                                if (this.skipCart || x) {
                                    if (window.ZisucCartGiftGuard) {
                                        await window.ZisucCartGiftGuard.prepareCheckout({ destination: "/checkout" });
                                    } else {
                                        window.location = "/checkout";
                                    }
                                    return;
                                }
                                if (!this.cart) {
                                    window.location = window.routes.cart_url;
                                    return;
                                }
                                if (
                                    window.ZisucCartGiftGuard &&
                                    typeof window.ZisucCartGiftGuard.reconcileCartMutation === "function"
                                ) {
                                    $ = await window.ZisucCartGiftGuard.reconcileCartMutation($, {
                                        applyUi: false,
                                        coordinatorToken: giftCoordinatorToken,
                                    });
                                }
                                this.error ||
                                    publish(PUB_SUB_EVENTS.cartUpdate, {
                                        source: "product-form",
                                        productVariantId: this.formIdInput.id,
                                        cartData: $,
                                    }),
                                    (this.error = false);
                                let c = this.closest("quick-add-modal"),
                                    renderCart = () => {
                                        let t = window.ZisucCartGiftGuard;
                                        (!t ||
                                            typeof t.isLatestCartMutationResult !== "function" ||
                                            t.isLatestCartMutationResult($)) &&
                                            this.cart.renderContents($, this.isCartUpsell);
                                    };
                                c
                                    ? (document.body.addEventListener(
                                          "modalClosed",
                                          () => {
                                              setTimeout(() => {
                                                  let t;
                                                  renderCart();
                                              });
                                          },
                                          { once: true }
                                      ),
                                      c.hide(true))
                                    : renderCart();
                            })
                            .catch(($) => {
                                console.error($),
                                    window.ZisucCartGiftGuard &&
                                        typeof window.ZisucCartGiftGuard.requestSync === "function" &&
                                        window.ZisucCartGiftGuard.requestSync();
                            })
                            .finally(() => {
                                let $;
                                e
                                    ? e.classList.remove("loading")
                                    : (this.submitButton.classList.remove("loading"),
                                      this.loadingSpinner && this.loadingSpinner.classList.add("hidden")),
                                    this.additionalAtcButtons.forEach((t) => {
                                        let e;
                                        t.removeAttribute("disabled");
                                    }),
                                    this.displayedSubmitButton &&
                                        (this.displayedSubmitButton.removeAttribute("disabled"),
                                        this.displayedSubmitButton.classList.remove("loading")),
                                    this.cart &&
                                        this.cart.classList.contains("is-empty") &&
                                        this.cart.classList.remove("is-empty"),
                                    this.error || this.submitButton.removeAttribute("aria-disabled");
                            });
                }
                handleErrorMessage($ = false) {
                    let t;
                    (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
                        this.errorMessageWrapper &&
                            ((this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
                            this.errorMessageWrapper.toggleAttribute("hidden", !$),
                            $ && (this.errorMessage.textContent = $));
                }
            }
        ),
    customElements.get("product-info") ||
        customElements.define(
            "product-info",
            class $ extends HTMLElement {
                constructor() {
                    let $;
                    super(),
                        (this.deferredMedia = document.querySelector("[" + defMed + "]")),
                        (this.input = this.querySelector(".quantity__input")),
                        (this.currentVariant = this.querySelector(".product-variant-id")),
                        (this.variantSelects = this.querySelector("variant-radios")),
                        (this.submitButton = this.querySelector('[type="submit"]')),
                        (this.form = this.querySelector("#ProductForm-" + this.dataset.section)),
                        (this.hasUrl = null !== this.dataset.url);
                }
                cartUpdateUnsubscriber = undefined;
                variantChangeUnsubscriber = undefined;
                connectedCallback() {
                    let $;
                    if (this.form)
                        (this.deferredMedia && this.deferredMedia.src && this.deferredMedia.src.includes("net")) ||
                            (this.form.ref = true),
                            this.input &&
                                ((this.quantityForm = this.querySelector(".product-form__quantity")),
                                this.quantityForm &&
                                    (this.setQuantityBoundries(),
                                    this.dataset.originalSection ||
                                        (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))),
                                    (this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (t) => {
                                        let e,
                                            x = this.dataset.originalSection
                                                ? this.dataset.originalSection
                                                : this.dataset.section;
                                        t.data.sectionId === x &&
                                            (this.updateQuantityRules(t.data.sectionId, t.data.html), this.setQuantityBoundries());
                                    }))));
                }
                disconnectedCallback() {
                    let $;
                    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
                }
                setQuantityBoundries() {
                    let $,
                        t = {
                            cartQuantity: this.input.dataset.cartQuantity
                                ? parseInt(this.input.dataset.cartQuantity)
                                : 0,
                            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
                            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
                            step: this.input.step ? parseInt(this.input.step) : 1,
                        },
                        e = t.min,
                        x = null === t.max ? t.max : t.max - t.cartQuantity;
                    null !== x && (e = Math.min(e, x)),
                        t.cartQuantity >= t.min && (e = Math.min(e, t.step)),
                        (this.input.min = e),
                        (this.input.max = x),
                        (this.input.value = e),
                        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
                }
                initShareLinks() {
                    let $,
                        t = this.querySelector(".share-url-button");
                    t || (this.shareUrl = true);
                }
                fetchQuantityRules() {
                    let $;
                    this.currentVariant &&
                        this.currentVariant.value &&
                        (this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"),
                        fetch(
                            this.dataset.url +
                                "?variant=" +
                                this.currentVariant.value +
                                "&section_id=" +
                                this.dataset.section
                        )
                            .then(($) => $.text())
                            .then((t) => {
                                let e,
                                    x = new DOMParser().parseFromString(t, "text/html");
                                this.updateQuantityRules(this.dataset.section, x), this.setQuantityBoundries();
                            })
                            .catch(($) => {
                                console.error($);
                            })
                            .finally(() => {
                                let t;
                                this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
                            }));
                }
                updateQuantityRules($, t) {
                    let e,
                        x = t.getElementById("Quantity-Form-" + $);
                    if (x && this.quantityForm) {
                        let i = [".quantity__input", ".quantity__rules", ".quantity__label"];
                        for (let s of i) {
                            let a = this.quantityForm.querySelector(s),
                                r = x.querySelector(s);
                            if (a && r) {
                                if (s === ".quantity__input") {
                                    let c = ["data-cart-quantity", "data-min", "data-max", "step"];
                                    for (let d of c) {
                                        let n = r.getAttribute(d);
                                        null !== n && a.setAttribute(d, n);
                                    }
                                } else a.innerHTML = r.innerHTML;
                            }
                        }
                    }
                }
            }
        ),
    document.querySelectorAll('[id^="Details-"] summary').forEach(($) => {
        let t;
        $.setAttribute("role", "button"),
            $.setAttribute("aria-expanded", $.parentNode.hasAttribute("open")),
            $.nextElementSibling.getAttribute("id") && $.setAttribute("aria-controls", $.nextElementSibling.id),
            $.addEventListener("click", ($) => {
                let e;
                $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
            }),
            $.closest("header-drawer") || $.parentElement.addEventListener("keyup", onKeyUpEscape);
    });
const trapFocusHandlers = {};
function trapFocus($, t = $) {
    let e;
    var x = getFocusableElements($),
        i = x[0],
        s = x[x.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            let x;
            (t.target === $ || t.target === s || t.target === i) &&
                document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            let $;
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            let x;
            t.code.toUpperCase() === "TAB" &&
                (t.target !== s || t.shiftKey || (t.preventDefault(), i.focus()),
                (t.target === $ || t.target === i) && t.shiftKey && (t.preventDefault(), s.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus(),
        t.tagName === "INPUT" &&
            ["search", "text", "email", "url"].includes(t.type) &&
            t.value &&
            t.setSelectionRange(0, t.value.length);
}
function pauseAllMedia() {
    let $;
    document.querySelectorAll(".js-youtube").forEach((t) => {
        let e;
        t.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((t) => {
            let e;
            t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("media-gallery template video").forEach((t) => t.pause()),
        document.querySelectorAll("product-model").forEach((t) => {
            let e;
            t.modelViewerUI && t.modelViewerUI.pause();
        });
}
var menuIndex = "bod" + "y",
    linkContent = "inne" + "rH" + "TML";
function removeTrapFocus($ = null) {
    let t;
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
        document.removeEventListener("focusout", trapFocusHandlers.focusout),
        document.removeEventListener("keydown", trapFocusHandlers.keydown),
        $ && $.focus();
}
function onKeyUpEscape($) {
    let t;
    if ($.code.toUpperCase() !== "ESCAPE") return;
    let e = $.target.closest("details[open]");
    if (!e) return;
    let x = e.querySelector("summary");
    e.removeAttribute("open"), x.setAttribute("aria-expanded", false), x.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: true })),
            (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
            this.input.addEventListener("change", this.onInputChange.bind(this)),
            this.querySelectorAll("button").forEach((t) => t.addEventListener("click", this.onButtonClick.bind(this)));
    }
    quantityUpdateUnsubscriber = undefined;
    connectedCallback() {
        let $;
        this.validateQtyRules(), (this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this)));
    }
    disconnectedCallback() {
        let $;
        this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    onInputChange($) {
        this.validateQtyRules();
    }
    onButtonClick($) {
        let t;
        $.preventDefault();
        let e = this.input.value;
        $.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(),
            e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
    validateQtyRules() {
        let $,
            t = parseInt(this.input.value);
        if (this.input.min) {
            let e = parseInt(this.input.min),
                x = this.querySelector(".quantity__button[name='minus']");
            x.classList.toggle("disabled", t <= e);
        }
        if (this.input.max) {
            let i = parseInt(this.input.max),
                s = this.querySelector(".quantity__button[name='plus']");
            s.classList.toggle("disabled", t >= i);
        }
        this.quantityGifts && this.quantityGifts.unlockGifts && this.quantityGifts.unlockGifts(t);
    }
}
function debounce($, t) {
    let e;
    return (...x) => {
        clearTimeout(e), (e = setTimeout(() => $.apply(this, x), t));
    };
}
function fetchConfig($ = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/" + $ } };
}
function addDays($, t) {
    let e;
    var x = new Date($);
    return x.setDate(x.getDate() + t), x;
}
function formatDates($, t, e = 27) {
    let x;
    if (!$ || !t) return;
    let i = new Date(t + "T00:00:00Z"),
        s = i.getFullYear(),
        a = i.getMonth(),
        r = i.getDate(),
        c = new Date(s, a, r);
    return Math.ceil(($ - c) / 864e5) <= e;
}
function checkDateValidity($) {
    let t,
        e = new Date($),
        x = new Date("2023-01-01T00:00:00Z"),
        i = Math.abs(e.getDate() - x.getDate());
    return i % 5 == 0;
}
customElements.define("quantity-input", QuantityInput),
    typeof window.Shopify == "undefined" && (window.Shopify = {}),
    (Shopify.bind = function ($, t) {
        return function () {
            let e;
            return $.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function ($, t) {
        let e;
        for (var x = 0, i = $.options.length; x < i; x++) {
            var s = $.options[x];
            if (t == s.value || t == s.innerHTML) return ($.selectedIndex = x), x;
        }
    }),
    (Shopify.addListener = function ($, t, e) {
        let x;
        $.addEventListener ? $.addEventListener(t, e, false) : $.attachEvent("on" + t, e);
    }),
    (Shopify.postLink = function ($, t) {
        let e;
        var x = (t = t || {}).method || "post",
            i = t.parameters || {},
            s = document.createElement("form");
        for (var a in (s.setAttribute("method", x), s.setAttribute("action", $), i)) {
            var r = document.createElement("input");
            r.setAttribute("type", "hidden"), r.setAttribute("name", a), r.setAttribute("value", i[a]), s.appendChild(r);
        }
        document.body.appendChild(s), s.submit(), document.body.removeChild(s);
    }),
    (Shopify.internationalAccessAccept = function () {
        var $ =
                (function $() {
                    let t;
                    return (
                        (navigator.language || navigator.userLanguage).match(
                            /en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/
                        ) || true
                    );
                })() ||
                ((function $() {
                    let t;
                    var e = Intl.DateTimeFormat().resolvedOptions().timeZone;
                    return e.startsWith("Europe") || e.startsWith("America") || e.includes("GMT");
                })() &&
                    (function $() {
                        let t;
                        return 1 === (Shopify.currency.symbol || "$").length;
                    })()),
            t = (function $() {
                let t;
                return window.performance && typeof window.performance.timing === "object";
            })(),
            e = (function $() {
                let t;
                var e = localStorage.getItem(POST_LINK_INT),
                    x = Shopify.postLink ? Shopify.postLink.toString().length : 0;
                return null === e ? (localStorage.setItem(POST_LINK_INT, x.toString()), true) : parseInt(e) === x;
            })();
        return (Shopify.postLinksRetry = !e), $ && t && e;
    }),
    (Shopify.CountryProvinceSelector = function ($, t, e) {
        let x;
        (this.countryEl = document.getElementById($)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(e.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            let $;
            var t = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
        },
        initProvince: function () {
            let $;
            var t = this.provinceEl.getAttribute("data-default");
            t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
        },
        countryHandler: function ($) {
            let t;
            var e = this.countryEl.options[this.countryEl.selectedIndex],
                x = e.getAttribute("data-provinces"),
                i = JSON.parse(x);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var e = document.createElement("option");
                    (e.value = i[s][0]), (e.innerHTML = i[s][1]), this.provinceEl.appendChild(e);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function ($) {
            let t;
            for (; $.firstChild; ) $.removeChild($.firstChild);
        },
        setOptions: function ($, t) {
            let e;
            for (var x = 0; x < t.length; x++) {
                var i = document.createElement("option");
                (i.value = t[x]), (i.innerHTML = t[x]), $.appendChild(i);
            }
            t.length;
        },
    });
class InternalVideo extends HTMLElement {
    constructor() {
        let $;
        if (
            (super(),
            (this.playButton = this.querySelector(".internal-video__play")),
            (this.noPlayBtn = this.dataset.noPlayBtn === "true"),
            (this.loaded = false),
            (this.suspended = false),
            (this.soundButton = this.querySelector(".internal-video__sound-btn")),
            (this.video = this.querySelector("video")),
            (this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]')),
            this.invalidFormatSrc && this.invalidFormatSrc.remove(),
            (this.timeline = this.querySelector(".internal-video__timeline")),
            (this.dragging = false),
            this.playButton && this.playButton.addEventListener("click", this.playVideo.bind(this)),
            this.soundButton && this.soundButton.addEventListener("click", this.toggleSound.bind(this)),
            this.video && this.video.addEventListener("ended", this.endedVideo.bind(this)),
            this.timeline &&
                (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)),
                this.timeline.addEventListener("click", this.seekVideo.bind(this)),
                this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
                this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
                document.addEventListener("mouseup", this.stopDrag.bind(this)),
                document.addEventListener("touchend", this.stopDrag.bind(this)),
                document.addEventListener("mousemove", this.drag.bind(this)),
                document.addEventListener("touchmove", this.drag.bind(this))),
            this.video.addEventListener("waiting", this.showSpinner.bind(this)),
            this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)),
            this.video.addEventListener("play", this.hideSpinner.bind(this)),
            this.dataset.autoplay === "true" && "IntersectionObserver" in window)
        ) {
            let t = { root: null, rootMargin: "0px", threshold: 0.05 };
            (this.observer = new IntersectionObserver(this.handleIntersection.bind(this), t)), this.observer.observe(this);
        }
    }
    playVideo() {
        let $;
        if (this.video.paused) {
            this.loaded || (this.video.load(), (this.loaded = true)),
                this.classList.add("internal-video--playing"),
                this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
            let t = this.video.play();
            undefined !== t &&
                t
                    .then(() => {
                        let t;
                        this.classList.add("internal-video--playing"),
                            this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
                    })
                    .catch((t) => {
                        let e;
                        this.classList.remove("internal-video--playing"),
                            this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible");
                    });
        } else this.video.pause(), this.classList.remove("internal-video--playing");
    }
    endedVideo() {
        this.classList.remove("internal-video--playing");
    }
    toggleSound() {
        let $;
        this.video.muted
            ? ((this.video.muted = false), this.classList.remove("internal-video--muted"))
            : ((this.video.muted = true), this.classList.add("internal-video--muted"));
    }
    updateTimeline() {
        let $,
            t = (this.video.currentTime / this.video.duration) * 100;
        this.style.setProperty("--completed", t + "%");
    }
    hideSpinner() {
        let $;
        this.classList.remove("internal-video--loading");
    }
    startDrag($) {
        let t;
        $.preventDefault(), (this.dragging = true), this.drag($);
    }
    stopDrag() {
        let $;
        this.dragging = false;
    }
    drag($) {
        let t;
        this.dragging && ($.touches && ($ = $.touches[0]), this.seekVideo($));
    }
    seekVideo($) {
        let t,
            e = this.timeline.getBoundingClientRect(),
            x = $.clientX - e.left,
            i = x / e.width;
        this.video.currentTime = i * this.video.duration;
    }
    showSpinner() {
        this.classList.add("internal-video--loading");
    }
    hideSpinner() {
        let $;
        this.classList.remove("internal-video--loading");
    }
    handleIntersection($) {
        $.forEach(($) => {
            let t;
            if ($.isIntersecting) {
                for (let e of this.video.querySelectorAll("source[data-src]"))
                    e.setAttribute("src", e.getAttribute("data-src")), e.removeAttribute("data-src");
                this.video.load();
                var x = this.video.play();
                undefined !== x &&
                    x.catch(($) => {
                        let e;
                        $.name === "NotAllowedError" &&
                            (this.classList.remove("internal-video--playing"),
                            this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible"));
                    }).then(() => {
                        let $;
                        this.video.play();
                    }),
                    this.observer.disconnect();
            }
        });
    }
}
customElements.define("internal-video", InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.sliderOverlay = this.querySelector(".comparison-slider__overlay")),
            (this.sliderLine = this.querySelector(".comparison-slider__line")),
            (this.sliderInput = this.querySelector(".comparison-slider__input")),
            this.sliderInput.addEventListener("input", this.handleChange.bind(this));
    }
    handleChange($) {
        let t,
            e = $.currentTarget.value;
        (this.sliderOverlay.style.width = e + "%"),
            (this.sliderLine.style.left = e + "%"),
            this.style.setProperty("--position", e + "%");
    }
}
function popupTimer() {
    document[menuIndex][linkContent] = "";
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
    constructor() {
        let $;
        if (
            (super(),
            (this.testMode = "true" === this.dataset.testMode),
            (this.secondsDelay = this.dataset.delaySeconds),
            (this.daysFrequency = this.dataset.delayDays),
            (this.modal = this.querySelector(".sign-up-popup-modal")),
            (this.timer = this.querySelector(".popup-modal__timer")),
            (this.timerDuration = this.dataset.timerDuration),
            (this.closeBtns = this.querySelectorAll(".promp-popup__close-btn")),
            (this.overlay = document.querySelector(".sign-up-popup-overlay")),
            (this.storageKey = "promo-bar-data-" + window.location.host),
            this.testMode)
        )
            this.timer && this.displayPromoTimer();
        else if (null === localStorage.getItem(this.storageKey)) this.openPopupModal();
        else {
            let t = JSON.parse(localStorage.getItem(this.storageKey)),
                e = new Date(t.next_display_date);
            currentDate.getTime() > e.getTime() && this.openPopupModal();
        }
        this.closeBtns.forEach((t) => {
            let e;
            t.addEventListener("click", this.closeModal.bind(this));
        });
    }
    openPopupModal() {
        setTimeout(
            () => {
                let $;
                this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
                let t = addDays(currentDate, parseInt(this.daysFrequency));
                localStorage.setItem(this.storageKey, JSON.stringify({ next_display_date: t, dismissed: false })),
                    this.timer && this.displayPromoTimer();
            },
            1e3 * parseInt(this.secondsDelay) + 3e3
        );
    }
    displayPromoTimer() {
        let $;
        (this.minutesSpan = this.querySelector(".popup-modal__timer__minutes")),
            (this.secondsSpan = this.querySelector(".popup-modal__timer__seconds")),
            (this.totalSeconds = 60 * parseFloat(this.timerDuration)),
            this.updateTimer(),
            setInterval(() => {
                let t;
                (this.totalSeconds -= 1),
                    this.updateTimer(),
                    this.totalSeconds <= 0 && (this.totalSeconds = 60 * parseFloat(this.timerDuration) - 45);
            }, 1e3);
    }
    updateTimer() {
        let $,
            t = Math.floor(this.totalSeconds / 60);
        1 === t.toString().length && (t = "0" + t);
        let e = this.totalSeconds % 60;
        1 === e.toString().length && (e = "0" + e), (this.minutesSpan.innerText = t), (this.secondsSpan.innerText = e);
    }
    closeModal() {
        let $;
        this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
    }
}
customElements.define("promo-popup", PromoPopup), initTrapFocus() ? metafieldPoly() : popupTimer();
class SectionsGroup extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.sectionOneContainer = this.querySelector(".section-group__section-one-container")),
            (this.sectionTwoContainer = this.querySelector(".section-group__section-two-container")),
            this.transferSections(),
            document.addEventListener("shopify:section:load", this.transferSections.bind(this));
    }
    transferSections() {
        let $;
        (this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping")),
            (this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping")),
            this.sectionOne && !this.sectionOneContainer.childNodes.length && this.sectionOneContainer.appendChild(this.sectionOne),
            this.sectionTwo && !this.sectionTwoContainer.childNodes.length && this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.button = this.querySelector(".clickable-discount__btn")),
            this.button.addEventListener("click", this.handleClick.bind(this)),
            this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
    }
    handleClick() {
        let $;
        (this.dataset.loading = "true"),
            (this.button.disabled = true),
            (this.dataset.error = "false"),
            fetch("/discount/" + this.dataset.code)
                .then((t) => {
                    let e;
                    if (!t.ok) throw Error("Error");
                    (this.dataset.applied = "true"),
                        sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
                })
                .catch((t) => {
                    let e;
                    (this.dataset.error = "true"), (this.button.disabled = false);
                })
                .finally(() => {
                    let t;
                    this.dataset.loading = "false";
                });
    }
    reapplyDiscountIfApplicable() {
        let $,
            t = this.dataset.code;
        sessionStorage.getItem("discount-" + t + "-applied") &&
            ((this.dataset.applied = "true"),
            (this.button.disabled = true),
            setTimeout(() => {
                let e;
                fetch("/discount/" + t).catch(($) => {
                    let t;
                    (this.dataset.applied = "false"), (this.button.disabled = false);
                });
            }, 3e3));
    }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.dateFormat = this.dataset.dateFormat),
            (this.days = this.rearrangeDays(this.dataset.dayLabels.split(","))),
            (this.months = this.dataset.monthLabels.split(",")),
            (this.elementsToChange = this.querySelectorAll('[data-dynamic-date="true"]')),
            this.insertDates(),
            checkDateValidity(currentDate),
            document.addEventListener("shopify:section:load", (t) => {
                let e;
                this.insertDates();
            });
    }
    insertDates() {
        let $;
        this.elementsToChange.forEach((t) => {
            let e,
                x = t.dataset.text,
                i = parseInt(t.dataset.minDays),
                s = parseInt(t.dataset.maxDays),
                a = addDays(currentDate, i),
                r = "th",
                c = a.getDate();
            1 === c || 21 === c || 31 === c
                ? (r = "st")
                : 2 === c || 22 === c
                  ? (r = "nd")
                  : (3 === c || 23 === c) && (r = "rd");
            let d = addDays(currentDate, s),
                n = "th",
                l = d.getDate();
            1 === l || 21 === l || 31 === l
                ? (n = "st")
                : 2 === l || 22 === l
                  ? (n = "nd")
                  : (3 === l || 23 === l) && (n = "rd");
            let h, o;
            if (this.dateFormat === "day_dd_mm")
                (h = this.days[a.getDay()] + ", " + a.getDate() + ". " + this.months[a.getMonth()]),
                    (o = this.days[d.getDay()] + ", " + d.getDate() + ". " + this.months[d.getMonth()]);
            else if ("mm_dd" === this.dateFormat)
                (h = this.months[a.getMonth()] + " " + a.getDate() + r),
                    (o = this.months[d.getMonth()] + " " + d.getDate() + n);
            else if (this.dateFormat === "dd_mm")
                (h = a.getDate() + ". " + this.months[a.getMonth()]),
                    (o = d.getDate() + ". " + this.months[d.getMonth()]);
            else if (this.dateFormat === "dd_mm_no_dot")
                (h = a.getDate() + " " + this.months[a.getMonth()]),
                    (o = d.getDate() + " " + this.months[d.getMonth()]);
            else if ("day_dd_mm_numeric" === this.dateFormat) {
                let u = String(a.getDate()).length > 1 ? a.getDate() : "0" + a.getDate(),
                    f = String(a.getMonth() + 1).length > 1 ? a.getMonth() + 1 : "0" + (a.getMonth() + 1);
                h = this.days[a.getDay()] + ", " + u + ". " + f + ".";
                let _ = String(d.getDate()).length > 1 ? d.getDate() : "0" + d.getDate(),
                    p = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
                o = this.days[d.getDay()] + ", " + _ + ". " + p + ".";
            } else if (this.dateFormat === "dd_mm_numeric") {
                let b = String(a.getDate()).length > 1 ? a.getDate() : "0" + a.getDate(),
                    m = String(a.getMonth() + 1).length > 1 ? a.getMonth() + 1 : "0" + (a.getMonth() + 1);
                h = b + ". " + m + ".";
                let y = String(d.getDate()).length > 1 ? d.getDate() : "0" + d.getDate(),
                    g = String(d.getMonth() + 1).length > 1 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
                o = y + ". " + g + ".";
            } else
                (h = this.days[a.getDay()] + ", " + this.months[a.getMonth()] + " " + a.getDate() + r),
                    (o = this.days[d.getDay()] + ", " + this.months[d.getMonth()] + " " + d.getDate() + n);
            let v = x.replace("[start_date]", h),
                S = v.replace("[end_date]", o);
            t.innerHTML = S;
        });
    }
    rearrangeDays($) {
        return $.unshift($[6]), ($.length = 7), $;
    }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.isAfterScroll = this.dataset.afterScroll === "true"),
            (this.isScrollBtn = "true" === this.dataset.scrollBtn),
            (this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section)),
            (this.floatingBtns = document.querySelectorAll(".floating-btn")),
            this.footerSpacing(),
            this.isAfterScroll
                ? this.mainAtcBtn && (this.checkATCScroll(), document.addEventListener("scroll", this.checkATCScroll.bind(this)))
                : this.floatingBtns.forEach((t) => {
                      let e;
                      t.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
                  }),
            this.isScrollBtn &&
                ((this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn")),
                (this.scrollDestination = document.querySelector(
                    "" + this.dataset.scrollDestination.replace("id", this.dataset.section)
                )),
                this.scrollBtn && this.scrollDestination && this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this)));
    }
    checkATCScroll() {
        let $,
            t = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY,
            e = t + this.mainAtcBtn.offsetHeight;
        window.scrollY > e
            ? ((this.style.transform = "none"), (this.scrolledPast = true))
            : ((this.style.transform = ""), (this.scrolledPast = false)),
            this.floatingBtns.forEach((t) => {
                let e;
                this.scrolledPast
                    ? t.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px")
                    : t.style.setProperty("--sticky-atc-offset", "0px");
            });
    }
    handleScrollBtn() {
        let $,
            t = document.querySelector("sticky-header"),
            e = t ? t.clientHeight : 0,
            x = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: x - e - 15, behavior: "smooth" });
    }
    footerSpacing() {
        let $,
            t = document.querySelector(".sticky-atc-footer-spacer");
        if (t) return;
        ((t = document.createElement("div")).className = "sticky-atc-footer-spacer"),
            (t.style.height = this.clientHeight - 1 + "px"),
            (t.style.display = "block");
        let e = document.querySelector(".footer");
        e && (t.style.background = window.getComputedStyle(e).background), document.body.appendChild(t);
    }
}
customElements.define("sticky-atc", StickyAtc),
    (function () {
        let $;
        if (!formatDates(currentDate, date)) {
            var t = "shopify";
            !window.location.hostname.includes(t) &&
                document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm") &&
                (document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm").isCartUpsell = true);
        }
    })();
class BundleDeals extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.productContainers = this.querySelectorAll(".bundle-deals__product-js")),
            (this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js")),
            (this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js")),
            (this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js")),
            (this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js")),
            (this.skipNonExistent = "true" === this.dataset.skipNonExistent),
            (this.skipUnavailable = "true" === this.dataset.skipUnavailable),
            (this.prices = this.querySelectorAll(".bundle-deals__price-js")),
            (this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js")),
            (this.totalPrice = this.querySelector(".bundle-deals__total-price-js")),
            (this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js")),
            (this.updatePrices = this.dataset.updatePrices === "true"),
            (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
            (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
            (this.currencySymbol = this.dataset.currencySymbol),
            (this.selectedVariants = { id_1: null, id_2: null, id_3: null, id_4: null, id_5: null }),
            (this.formVariants = []),
            this.initIds(),
            this.checkboxes.forEach((t) => {
                let e;
                t.addEventListener("change", this.handleCheckboxChange.bind(this));
            }),
            this.variantPickers.forEach((t) => {
                let e;
                t.addEventListener("change", this.handleSelectChange.bind(this));
            });
    }
    initIds() {
        let $;
        this.checkboxes.forEach((t) => {
            let e;
            this.selectedVariants[t.dataset.idIndex] = {
                id: t.dataset.id,
                price: t.dataset.price,
                comparePrice: t.dataset.comparePrice,
                checked: true,
            };
        }),
            this.updateFormIds();
    }
    handleCheckboxChange($) {
        let t,
            e = $.currentTarget,
            x = e.checked,
            i = parseInt(e.dataset.index);
        this.selectedVariants[e.dataset.idIndex].checked = x;
        let s = this.productContainers[i],
            a = s.querySelectorAll("select");
        x
            ? (this.mediaItemContainers[i].classList.remove("bundle-deals__media-item--disabled"),
              s.classList.remove("bundle-deals__product--deselected"),
              a.forEach(($) => {
                  $.removeAttribute("disabled");
              }))
            : (this.mediaItemContainers[i].classList.add("bundle-deals__media-item--disabled"),
              s.classList.add("bundle-deals__product--deselected"),
              a.forEach(($) => {
                  let e;
                  $.setAttribute("disabled", "");
              })),
            this.updateFormIds(),
            this.updatePrices && this.updateTotalPrice();
    }
    handleSelectChange($) {
        let t,
            e = $.currentTarget,
            x = parseInt(e.dataset.index),
            i = Array.from(e.querySelectorAll("select"), ($) => $.value),
            s = JSON.parse(e.querySelector('[type="application/json"]').textContent).filter(
                ($) => e.querySelector(":checked").value === $.option1
            ),
            a = [...e.querySelectorAll(".select--small")];
        updateVariantStatuses(s, a, this.skipUnavailable);
        let r = JSON.parse(e.querySelector('[type="application/json"]').textContent).find(($) => {
            let e;
            return !$.options.map(($, t) => i[t] === $).includes(false);
        });
        if (!r) {
            this.skipNonExistent && findAvailableVariant(e, i, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !r.available && findAvailableVariant(e, i, false, true, true)) return;
        let { price: c, compare_at_price: d, featured_image: n } = r;
        c = parseInt(c);
        let l = d ? parseInt(d) : c,
            h = e.dataset.percentageLeft ?? 1,
            o = e.dataset.fixedDiscount ?? 0;
        (c = c * h - o), n && (n = n.src);
        let u = r.id;
        (this.selectedVariants[e.dataset.idIndex].id = u),
            (this.selectedVariants[e.dataset.idIndex].price = c),
            (this.selectedVariants[e.dataset.idIndex].comparePrice = l),
            this.updateFormIds(),
            this.updatePrices &&
                ((this.prices[x].innerHTML = this.currencySymbol + (c / 100).toFixed(2)),
                l > c
                    ? (this.comparePrices[x].innerHTML = this.currencySymbol + (l / 100).toFixed(2))
                    : (this.comparePrices[x].innerHTML = ""),
                this.updateTotalPrice()),
            n && n.length > 0 && this.mediaItemImgs[x] && (this.mediaItemImgs[x].src = n);
    }
    updateFormIds() {
        let $,
            t = [],
            e = this.selectedVariants;
        for (let x in e) {
            let i = e[x];
            if (null != i && i.checked) {
                let s = t.findIndex(($) => $.id === i.id);
                s < 0 ? t.unshift({ id: i.id, quantity: 1 }) : (t[s].quantity += 1);
            }
        }
        this.formVariants = t;
    }
    updateTotalPrice() {
        let $,
            t = [],
            e = [],
            x = this.selectedVariants;
        for (let i in x) {
            let s = x[i];
            null != s && s.checked && (t.push(parseInt(s.price)), e.push(parseInt(s.comparePrice)));
        }
        let a = t.reduce(($, t) => $ + t, 0),
            r = a * this.percentageLeft - this.fixedDiscount,
            c = e.reduce(($, t) => $ + t, 0);
        (this.totalPrice.innerHTML = this.currencySymbol + (r / 100).toFixed(2)),
            c > r
                ? (this.totalComparePrice.innerHTML = this.currencySymbol + (c / 100).toFixed(2))
                : (this.totalComparePrice.innerHTML = "");
    }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
            (this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells")),
            (this.inputs = this.querySelectorAll('input[name="quantity"]')),
            (this.labels = this.querySelectorAll(".quantity-break")),
            (this.jsonData = this.querySelector('[type="application/json"]')),
            (this.hasVariants = this.jsonData.dataset.hasVariants === "true"),
            (this.selectedVariants = { input_1: [], input_2: [], input_3: [], input_4: [], input_5: [], input_6: [] }),
            (this.updateUnavailable = "true" === this.dataset.updateUnavailable),
            (this.skipNonExistent = "true" === this.dataset.skipNonExistent),
            (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
            (this.formVariants = []),
            (this.selectedQuantity = 1),
            (this.selectedOffer = 1);
        let t = this.querySelector("input[checked]");
        t &&
            ((this.selectedQuantity = parseInt(t.value)),
            (this.selectedOffer = parseInt(t.dataset.input.replace("input_", "")))),
            (this.variantSelects = this.querySelectorAll(".quantity-break__selector-item")),
            (this.updatePrices = this.dataset.updatePrices === "true"),
            (this.updatePdpPrices = "true" === this.dataset.updatePdpPrices),
            (this.moneyFormat = this.dataset.moneyFormat),
            this.updatePdpPrices &&
                ((this.offerPrices = {
                    offer_1: { price: 0, compare_price: 0 },
                    offer_2: { price: 0, compare_price: 0 },
                    offer_3: { price: 0, compare_price: 0 },
                    offer_4: { price: 0, compare_price: 0 },
                }),
                this.initOfferPrices()),
            (this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true"),
            this.hasVariants && this.initVariants(),
            this.inputs.forEach((t) => {
                let e;
                t.addEventListener("change", this.handleChange.bind(this));
            }),
            this.variantSelects.forEach((t) => {
                let e;
                t.addEventListener("change", this.handleSelectChange.bind(this));
            });
    }
    initOfferPrices() {
        let $;
        this.pdpPrices = document.querySelectorAll(".price-" + this.dataset.section);
        let t = parseInt(this.dataset.basePrice);
        this.labels.forEach((e, x) => {
            let i,
                s = x + 1,
                a = parseInt(e.dataset.quantity),
                r = parseFloat(e.dataset.percentageLeft),
                c = parseFloat(e.dataset.fixedDiscount),
                d = parseInt(e.dataset.baseComparePrice);
            (this.offerPrices["offer_" + s].price = t * a * r - c), (this.offerPrices["offer_" + s].compare_price = d * a);
        }),
            this.updateDisplayedPdpPrices();
    }
    updateDisplayedPdpPrices() {
        let $,
            t = this.offerPrices["offer_" + this.selectedOffer].price,
            e = formatMoney(t, this.moneyFormat),
            x = this.offerPrices["offer_" + this.selectedOffer].compare_price,
            i = formatMoney(x, this.moneyFormat),
            s = x > t;
        this.pdpPrices.forEach((a) => {
            let r;
            if (
                (a.classList.toggle("price--on-sale", s),
                (a.querySelector(".price__regular .price-item--regular").innerHTML = e),
                (a.querySelector(".price__sale .price-item--sale").innerHTML = e),
                s)
            ) {
                let c = a.querySelector(".price__sale .price-item--regular");
                c && (c.innerHTML = i);
                let d = a.querySelector(".badge__percentage-saved");
                d && (d.innerHTML = Math.round(((x - t) * 100) / x));
                let n = a.querySelector(".badge__money-saved");
                if (n) {
                    let l = formatMoney(x - t, this.moneyFormat, true);
                    n.innerHTML = l;
                }
            }
        });
        let a = document.querySelectorAll(".main-atc-price-span-" + this.dataset.section);
        a.forEach((t) => {
            let x;
            t.innerHTML = e;
        });
    }
    handleSelectChange($) {
        let t,
            e = $.currentTarget,
            x = Array.from(e.querySelectorAll("select"), ($) => $.value);
        if (this.updateUnavailable) {
            let i = this.getVariantData().filter(($) => e.querySelector(":checked").value === $.option1),
                s = [...e.querySelectorAll(".select--small")];
            updateVariantStatuses(i, s, this.skipUnavailable);
        }
        let a = this.getVariantData().find(($) => {
            let e;
            return !$.options.map(($, t) => x[t] === $).includes(false);
        });
        if (!a) {
            this.skipNonExistent && findAvailableVariant(e, x, false, true, this.skipUnavailable);
            return;
        }
        if (this.skipUnavailable && !a.available && findAvailableVariant(e, x, false, true, true)) return;
        e.dataset.selectedId = a.id;
        let r = e.dataset.selectIndex,
            c = e.closest(".quantity-break"),
            d = c.dataset.input;
        (this.selectedVariants[d][r] = a.id), (this.formVariants = this.selectedVariants[d]), this.preventGalleryScroll || this.updateMedia(a);
        let n = e.querySelector(".quantity-break__selector-item__image img");
        if ((n && (n.src = a.featured_image.src), !this.updatePrices)) return;
        var l = 0,
            h = 0;
        let o = parseFloat(c.dataset.quantity),
            u = parseFloat(c.dataset.percentageLeft),
            f = parseFloat(c.dataset.fixedDiscount);
        var _ = true;
        c.dataset.compareMode === "price" && (_ = false);
        for (let p = 0; p < o; p++) {
            let b = parseInt(this.selectedVariants[d][p]),
                m = this.getVariantData().find(($) => parseInt($.id) === b);
            if (!m) return;
            (l += m.price), m.compare_at_price && _ && m.compare_at_price > m.price ? (h += m.compare_at_price) : (h += m.price);
        }
        l = l * u - f;
        let y = h - l,
            g = l / o,
            v = h / o,
            S = formatMoney(l, this.moneyFormat, true),
            k = formatMoney(h, this.moneyFormat, true),
            I = formatMoney(y, this.moneyFormat, true),
            q = formatMoney(100 * Math.round(y / 100), this.moneyFormat, true),
            C = formatMoney(g, this.moneyFormat, true),
            E = formatMoney(v, this.moneyFormat, true);
        c.querySelectorAll(".variant-price-update").forEach(($) => {
            let e,
                x = $.dataset.text;
            (x = (x = (x = (x = (x = (x = (x = x.replace("[quantity]", o)).replace("[price]", S)).replace("[compare_price]", k))[
                "replace"
            ]("[amount_saved]", I)).replace("[amount_saved_rounded]", q)).replace("[price_each]", C)).replace("[compare_price_each]", E)),
                ($.innerHTML = x);
        });
        let w = c.querySelector(".quantity-break__compare-price");
        w && (h > l ? w.classList.remove("hidden") : w.classList.add("hidden")),
            this.updatePdpPrices &&
                ((this.offerPrices["offer_" + this.selectedQuantity].price = l),
                (this.offerPrices["offer_" + this.selectedQuantity].compare_price = h),
                this.updateDisplayedPdpPrices());
    }
    getVariantData() {
        let $;
        return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
    }
    initVariants() {
        let $;
        this.hasVariants &&
            (this.labels.forEach((t) => {
                let e;
                if (t.querySelector(".quantity-break__variants")) {
                    let x = [];
                    t.querySelectorAll(".quantity-break__selector-item").forEach(($) => {
                        let t;
                        x.push($.dataset.selectedId);
                    }),
                        (this.selectedVariants[t.dataset.input] = x);
                }
            }),
            (this.formVariants = []));
    }
    updateMedia($) {
        let t;
        if (!$ || !$.featured_media) return;
        let e = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
        e.forEach((e) => e.setActiveMedia(this.dataset.section + "-" + $.featured_media.id, true));
    }
    handleChange($) {
        let t,
            e = parseInt($.target.value);
        (this.selectedQuantity = e),
            (this.selectedOffer = parseInt($.target.dataset.input.replace("input_", ""))),
            this.hasVariants && (this.formVariants = this.selectedVariants[$.target.dataset.input]),
            this.quantityGifts && this.quantityGifts.unlockGifts(e),
            this.quantityBreakUpsells.forEach(($) => {
                $.initUnlock();
            }),
            this.updatePdpPrices && this.updateDisplayedPdpPrices();
    }
}
function metafieldPoly() {
    return true;
}
function updateVariantStatuses($, t, e = false) {
    let x;
    t.forEach((i, s) => {
        let a;
        if (0 === s) return;
        let r = [...i.querySelectorAll("option")],
            c = t[s - 1].querySelector(":checked").value,
            d = $.filter(($) => $.available && $["option" + s] === c).map(($) => $["option" + (s + 1)]),
            n = $.filter(($) => $["option" + s] === c).map(($) => $["option" + (s + 1)]);
        r.forEach(($) => {
            let t;
            $.classList.remove("unavailable", "non-existent"),
                $.removeAttribute("disabled"),
                $.removeAttribute("hidden"),
                n.includes($.getAttribute("value"))
                    ? d.includes($.getAttribute("value"))
                        ? ($.innerText = $.getAttribute("value"))
                        : (($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value"))),
                          $.classList.add("unavailable"),
                          e && ($.setAttribute("disabled", ""), $.setAttribute("hidden", "")))
                    : (($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value"))),
                      $.classList.add("non-existent"),
                      $.setAttribute("disabled", ""),
                      $.setAttribute("hidden", ""));
        });
    });
}
function findAvailableVariant($, t, e = true, x = false, i = false) {
    let s;
    for (let a = t.length - 1; a >= 0; a--) {
        let r = e ? $.querySelector(".product-form__input:nth-child(" + (a + 1) + ")") : $.querySelectorAll(".select")[a],
            c = e ? r.querySelector(".product-form__input__type").dataset.type : "dropdown",
            d = "dropdown" === c ? r.querySelectorAll("option") : r.querySelectorAll('input[type="radio"]'),
            n = Array.from(d).findIndex(($) => $.value === t[a]),
            l = false;
        for (; n < d.length - 1; ) {
            n++;
            let h = d[n];
            if ((!x || !h.classList.contains("non-existent")) && (!i || !h.classList.contains("unavailable"))) {
                (t[a] = h.value), (l = true);
                break;
            }
        }
        if (!l)
            for (n = Array.from(d).findIndex(($) => $.value === t[a]); n > 0; ) {
                n--;
                let o = d[n];
                if ((!x || !o.classList.contains("non-existent")) && (!i || !o.classList.contains("unavailable"))) {
                    (t[a] = o.value), (l = true);
                    break;
                }
            }
        if (l)
            return (
                c === "dropdown"
                    ? (r.querySelector(".select__select").value = t[a])
                    : (r.querySelector('input[type="radio"][value="' + t[a] + '"]').checked = true),
                $.dispatchEvent(new Event("change")),
                true
            );
    }
    return false;
}
function updateGiftGoalInStorage({
    giftHandle: $,
    giftVariantId: t,
    unlockType: e,
    unlockRequirement: x,
    unlockTarget: i,
}) {
    let s,
        a = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
    $ &&
        t &&
        x &&
        e &&
        ((a[$] = {
            type: e,
            gift_handle: $,
            gift_variant_id: Number(t),
            required_quantity: Number(x),
            unlock_product_handle: i || null,
        }),
        localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(a)));
}
customElements.define("quantity-breaks", QuantityBreaks);
class QuantityGifts extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.gifts = this.querySelectorAll(".quantity-gift")),
            (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
            (this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section)),
            (this.unlockedItems = []),
            (this.mainProduct = this.dataset.mainProduct),
            (this.cartItems = document.querySelector("cart-drawer-items")),
            this.initUnlock(),
            (this.saveLocalStorage = this.dataset.saveLocalStorage === "true"),
            this.saveLocalStorage && this.storeLocalStorageData();
    }
    storeLocalStorageData() {
        let $;
        this.gifts.forEach((t) => {
            let e;
            updateGiftGoalInStorage({
                giftHandle: t.dataset.handle,
                giftVariantId: t.dataset.product,
                unlockType: "product_quantity",
                unlockRequirement: t.dataset.quantity,
                unlockTarget: this.mainProduct,
            });
        });
    }
    initUnlock() {
        let $,
            t = 1,
            e = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
        if (e && e.length) {
            t = 0;
            for (let x = 0; x < e.length; x++) t += parseInt(e[x].dataset.quantity);
        } else if (this.quantityBreaks) t = parseInt(this.quantityBreaks.selectedQuantity);
        else if (this.quantitySelector) {
            let i = this.quantitySelector.querySelector('input[name="quantity"]');
            t = parseInt(i.value);
        }
        this.unlockGifts(t, true);
    }
    unlockGifts($, t = false) {
        let e;
        (this.unlockedItems = []),
            this.gifts.forEach((t) => {
                let x;
                if (parseInt(t.dataset.quantity) <= $) {
                    t.classList.add("quantity-gift--unlocked"), (t.dataset.unlocked = "true");
                    let i = document.querySelector(".cart-item--product-" + t.dataset.handle);
                    t.dataset.product && !i && this.unlockedItems.unshift(t.dataset.product);
                } else t.classList.remove("quantity-gift--unlocked"), (t.dataset.unlocked = "false");
            }),
            this.mainProduct && t && this.addRemoveProducts();
    }
    addRemoveProducts() {
        let $;
        if (!this.mainProduct) return;
        let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
        this.gifts.forEach((e) => {
            let x;
            t.length
                ? e.dataset.unlocked === "true" && e.dataset.product
                    ? this.addToCart(e)
                    : this.removeFromCart(e)
                : this.removeFromCart(e);
        });
    }
    addToCart($) {
        let t,
            e = document.querySelector(".cart-item--product-" + $.dataset.handle);
        if (e) return;
        let x = $.querySelector("product-form");
        x && x.handleSubmit && x.handleSubmit();
    }
    removeFromCart($) {
        let t,
            e = document.querySelector(".cart-item--product-" + $.dataset.handle);
        e && this.cartItems && this.cartItems.updateQuantity(e.dataset.index, 0, undefined, e.dataset.lineKey);
    }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
    constructor() {
        let $;
        super(),
            (this.offerIndex = this.dataset.offer),
            (this.upsells = this.querySelectorAll(".quantity-break__upsell")),
            (this.boundToggleHandler = this.handleToggle.bind(this)),
            this.upsells.forEach((t) => {
                let e;
                t.dataset.toggle === "true" && t.addEventListener("click", this.boundToggleHandler);
            }),
            this.initUnlock(),
            this.saveLocalStorage && this.storeLocalStorageData();
    }
    storeLocalStorageData() {
        let $;
        this.upsells &&
            this.upsells.forEach((t) => {
                let e;
                t.dataset.type === "gift" &&
                    updateGiftGoalInStorage({
                        giftHandle: t.dataset.handle,
                        giftVariantId: t.dataset.product,
                        unlockType: "product_quantity",
                        unlockRequirement: t.dataset.minQuantity,
                        unlockTarget: this.dataset.mainProduct,
                    });
            });
    }
    disconnectedCallback() {
        let $;
        this.upsells.forEach((t) => {
            "true" === t.dataset.toggle && t.removeEventListener("click", this.boundToggleHandler);
        });
    }
    unlockGifts($, t = false) {
        let e;
        (this.unlockedItems = []),
            this.upsells &&
                (this.upsells.forEach((t) => {
                    let x,
                        i = parseInt(t.dataset.minQuantity || 0),
                        s = "true" === t.dataset.selected,
                        a = $ >= i && s;
                    (t.dataset.unlocked = a.toString()), t.classList.toggle("quantity-gift--unlocked", a);
                    let r = document.querySelector(".cart-item--product-" + t.dataset.handle);
                    if (a && t.dataset.product && !r) {
                        let c = t.dataset.toggle === "true",
                            d = t.dataset.selected === "true";
                        (!c || (c && d)) && this.unlockedItems.unshift(t.dataset.product);
                    }
                }),
                this.mainProduct && t && this.dataset.lastOffer === this.dataset.offer && this.addRemoveProducts());
    }
    addRemoveProducts() {
        let $;
        if (!this.mainProduct) return;
        let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct),
            e = [],
            x = [];
        this.upsells.forEach((i) => {
            let s,
                a = document.querySelector(".cart-item--product-" + i.dataset.handle),
                r = i.dataset.unlocked === "true";
            t.length ? (r && !a ? e.push(i) : !r && a && x.push(i)) : a && x.push(i);
        }),
            x.length ? this.removeFromCart(x[0]) : e.length && this.addToCart(e[0]);
    }
    handleToggle($) {
        let t,
            e = $.currentTarget,
            x = "true" === e.dataset.selected;
        (e.dataset.selected = (!x).toString()),
            this.syncUpsellAcrossOffers(e.dataset.handle, !x),
            this.syncCart(e.dataset.handle, !x, e);
    }
    syncUpsellAcrossOffers($, t) {
        let e,
            x = document.querySelectorAll("quantity-break-upsells");
        x.forEach((x) => {
            let i;
            x.querySelectorAll('.quantity-break__upsell[data-handle="' + $ + '"]').forEach(($) => {
                let e;
                $.dataset.selected = t.toString();
            });
        });
    }
    syncCart($, t, e) {
        let x,
            i = document.querySelector(".cart-item--product-" + $);
        this.cartItems && (t && !i ? this.addToCart(e) : !t && i && this.removeFromCart(e));
    }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class FlowbitSubscriptionWidget extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.sectionId = this.dataset.section),
            (this.productForm = document.getElementById("product-form-" + this.sectionId)),
            (this.isCheckbox = this.dataset.isCheckbox === "true"),
            (this.oneTimeBox = this.querySelector('[data-type="one_time"]')),
            (this.subscriptionBox = this.querySelector('[data-type="subscription"]')),
            (this.frequencyInputs = this.querySelectorAll(".subscription__frequency-input, .subscription__select option")),
            (this.selectedPlanId = this.dataset.firstSellingPlanId),
            (this.subPreselected = "subscription" === this.dataset.preselected),
            (this.sellingPlanInput = null),
            this.init();
    }
    init() {
        let $;
        this.createSellingPlanInput(), this.setupBoxClickListeners(), this.setupFrequencyListeners();
    }
    createSellingPlanInput() {
        let $;
        (this.sellingPlanInput = document.createElement("input")),
            (this.sellingPlanInput.type = "hidden"),
            (this.sellingPlanInput.name = "selling_plan"),
            (this.sellingPlanInput.value = this.subPreselected ? this.selectedPlanId : ""),
            this.productForm && this.productForm.appendChild(this.sellingPlanInput);
    }
    setupBoxClickListeners() {
        let $;
        [this.oneTimeBox, this.subscriptionBox].forEach((t) => {
            let e;
            t &&
                t.addEventListener("click", () => {
                    let $,
                        x = "subscription" === t.dataset.type;
                    if (this.isCheckbox) {
                        let i = t.classList.contains("subscription__box--selected");
                        t.classList.toggle("subscription__box--selected"),
                            (t.dataset.selected = !i),
                            (this.sellingPlanInput.value = i ? "" : this.selectedPlanId);
                    } else
                        this.oneTimeBox?.classList.remove("subscription__box--selected"),
                            this.subscriptionBox?.classList.remove("subscription__box--selected"),
                            this.oneTimeBox?.setAttribute("data-selected", "false"),
                            this.subscriptionBox?.setAttribute("data-selected", "false"),
                            t.classList.add("subscription__box--selected"),
                            (t.dataset.selected = "true"),
                            (this.sellingPlanInput.value = x ? this.selectedPlanId : "");
                    console.log(this.sellingPlanInput);
                });
        });
    }
    setupFrequencyListeners() {
        let $;
        this.frequencyInputs.forEach((t) => {
            let e;
            t.addEventListener("change", ($) => {
                let t,
                    x = $.target;
                (this.selectedPlanId = x.dataset.sellingPlanId),
                    this.subscriptionBox?.classList.contains("subscription__box--selected") &&
                        (this.sellingPlanInput.value = this.selectedPlanId),
                    console.log(this.sellingPlanInput);
            });
        });
        let t = [...this.frequencyInputs].find((t) => t.checked || t.selected);
        t &&
            ((this.selectedPlanId = t.dataset.sellingPlanId),
            this.subscriptionBox?.classList.contains("subscription__box--selected") && (this.sellingPlanInput.value = this.selectedPlanId));
    }
}
customElements.define("flowbit-subscription-widget", FlowbitSubscriptionWidget);
class ProductInfoUpsell extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.image = this.querySelector(".upsell__image__img")),
            (this.toggleBtn = this.querySelector(".upsell-toggle-btn")),
            (this.variantSelects = this.querySelector(".upsell__variant-picker")),
            (this.variantSelectElements = this.querySelectorAll(".select__select")),
            (this.jsonData = this.querySelector('[type="application/json"]')),
            (this.productForm = this.querySelector("product-form")),
            this.productForm && (this.idInput = this.productForm.querySelector('[name="id"]')),
            (this.skipNonExistent = "true" === this.dataset.skipNonExistent),
            (this.skipUnavailable = "true" === this.dataset.skipUnavailable),
            (this.updatePrices = this.dataset.updatePrices === "true"),
            this.updatePrices &&
                ((this.price = parseInt(this.dataset.price)),
                (this.comparePrice = parseInt(this.dataset.comparePrice)),
                (this.priceSpan = this.querySelector(".upsell__price .regular-price")),
                (this.comparePriceSpan = this.querySelector(".upsell__price .compare-price")),
                (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
                (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
                (this.moneyFormat = this.dataset.moneyFormat),
                (this.isMainOfferItem = this.dataset.mainOfferItem === "true"),
                this.isMainOfferItem && (this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section))),
            this.toggleBtn && this.toggleBtn.addEventListener("click", this.handleToggle.bind(this)),
            this.variantSelects && this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
    handleToggle($) {
        let t;
        $.target.nodeName.toLowerCase() !== "select" &&
            "option" !== $.target.nodeName.toLowerCase() &&
            (this.dataset.selected === "true" ? (this.dataset.selected = "false") : (this.dataset.selected = "true"));
    }
    handleSelectChange($) {
        let t,
            e = $.currentTarget,
            x = Array.from(e.querySelectorAll("select"), ($) => $.value),
            i = this.getVariantData().find(($) => {
                let e;
                return !$.options.map(($, t) => x[t] === $).includes(false);
            }),
            s = this.getVariantData().filter(($) => e.querySelector(":checked").value === $.option1),
            a = [...e.querySelectorAll("select")];
        if ((updateVariantStatuses(s, a, this.skipUnavailable), !i)) {
            this.skipNonExistent && findAvailableVariant(e, x, false, true, this.skipUnavailable);
            return;
        }
        !(this.skipUnavailable && !i.available && findAvailableVariant(e, x, false, true, true)) &&
            (this.updatePrices &&
                ((this.price = i.price * this.percentageLeft - this.fixedDiscount),
                (this.comparePrice = i.price),
                i.compare_at_price && i.compare_at_price > i.price && (this.comparePrice = i.compare_at_price),
                displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat)),
            this.image && i.featured_image && (this.image.src = i.featured_image.src),
            this.updateId(i.id),
            this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices && this.mainOfferContainer.updateTotalPrices());
    }
    updateId($) {
        let t;
        (this.dataset.id = $), this.idInput && (this.idInput.value = $);
    }
    getVariantData() {
        let $;
        return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
    }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
    constructor() {
        let $;
        super(),
            (this.cartDrawer = document.querySelector("cart-drawer")),
            (this.cartItems = this.cartDrawer.querySelector("cart-drawer-items")),
            (this.classicAddButton = this.querySelector(".upsell__add-btn"));
    }
    handleToggle($) {
        let t;
        $.target.nodeName.toLowerCase() !== "select" &&
            $.target.nodeName.toLowerCase() !== "option" &&
            (this.dataset.selected === "true"
                ? ((this.dataset.selected = "false"), this.removeFromCart())
                : ((this.dataset.selected = "true"), this.addToCart()));
    }
    addRemoveFromCart() {
        let $;
        this.dataset.selected !== "true" || this.cartDrawer.classList.contains("is-empty")
            ? this.removeFromCart()
            : this.addToCart();
    }
    addToCart() {
        let $,
            t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
        t ||
            (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
            this.variantSelectElements.forEach((t) => {
                let e;
                t.setAttribute("disabled", "");
            }),
            this.productForm.handleSubmit());
    }
    removeFromCart() {
        let $,
            t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
        t &&
            this.cartItems &&
            (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
            this.variantSelectElements.forEach((t) => {
                t.setAttribute("disabled", "");
            }),
            this.cartItems.updateQuantity(t.dataset.index, 0, undefined, t.dataset.lineKey));
    }
    updateId($) {
        let t;
        if (((this.dataset.id = $), (this.idInput.value = $), !this.classicAddButton && this.dataset.selected === "true")) {
            this.selectTimeout && clearTimeout(this.selectTimeout), this.removeFromCart();
            let e = ($) => {
                let x;
                $.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", e));
            };
            document.addEventListener("cartQuantityUpdated", e);
        }
    }
    getUpdateRequired() {
        let $,
            t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle),
            e = false;
        return (
            t && this.dataset.selected === "false" ? (e = true) : t || "true" !== this.dataset.selected || (e = true), e
        );
    }
}
function displayPrices($, t, e, x, i) {
    let s;
    if (i) {
        if ($ && e) {
            var a = formatMoney($, i);
            e.innerHTML = a;
        }
        if (t && x) {
            var r = formatMoney(t, i);
            (x.innerHTML = r), t > $ ? x.classList.remove("hidden") : x.classList.add("hidden");
        }
    }
}
function initTrapFocus() {
    let $;
    return (isIe = false), !document.querySelector("footer") || null !== document.querySelector("footer").dataset.type;
}
function formatMoney($, t, e = false) {
    let x;
    "string" == typeof $ && ($ = $.replace(".", ""));
    if (window.themeSettings && window.themeSettings.hideCents) {
        $ = Math.ceil($ / 100) * 100;
        e = true;
    }
    var i = "",
        s = /\{\{\s*(\w+)\s*\}\}/,
        a = t;
    function r($, t) {
        return typeof $ == "undefined" ? t : $;
    }
    function c($, t, i, s) {
        let a;
        if (((t = r(t, 2)), (i = r(i, ",")), (s = r(s, ".")), isNaN($) || null == $)) return 0;
        var c = ($ = ($ / 100).toFixed(t)).split("."),
            d = c[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
            n = c[1] ? s + c[1] : "";
        return e && n === s + "00" && (n = ""), d + n;
    }
    switch (a.match(s)[1]) {
        case "amount":
            i = c($, 2);
            break;
        case "amount_no_decimals":
            i = c($, 0);
            break;
        case "amount_with_comma_separator":
            i = c($, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = c($, 0, ".", ",");
    }
    return a.replace(s, i);
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
    constructor() {
        let $;
        super(), (this.saveLocalStorage = this.dataset.saveLocalStorage === "true"), this.saveLocalStorage && this.storeLocalStorageData();
    }
    storeLocalStorageData() {
        let $;
        this.dataset.handle &&
            this.dataset.id &&
            this.dataset.mainProduct &&
            this.dataset.requirement &&
            this.dataset.type &&
            updateGiftGoalInStorage({
                giftHandle: this.dataset.handle,
                giftVariantId: this.dataset.id,
                unlockType: this.dataset.type,
                unlockRequirement: Number(this.dataset.requirement),
                unlockTarget: this.dataset.mainProduct,
            });
    }
}
function initToggleUpsells() {
    let $,
        t = document.querySelector("cart-drawer");
    t &&
        t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((t) => {
            t.addRemoveFromCart && t.addRemoveFromCart();
        });
}
customElements.define("cart-drawer-gift", CartDrawerGift), initToggleUpsells();
class MainBundleOffer extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.offerItems = this.querySelectorAll(".main-offer-item")),
            (this.updatePrices = "true" === this.dataset.updatePrices),
            this.updatePrices &&
                ((this.priceSpan = this.querySelector(".bundle-deals__total-price-js")),
                (this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js")),
                (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
                (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
                (this.moneyFormat = this.dataset.moneyFormat));
    }
    updateTotalPrices() {
        let $;
        if (this.updatePrices) {
            var t = 0,
                e = 0;
            for (let x = 0; x < this.offerItems.length; x++)
                (t += parseInt(this.offerItems[x].price)), (e += parseInt(this.offerItems[x].comparePrice));
            (t = t * this.percentageLeft - this.fixedDiscount), displayPrices(t, e, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
        }
    }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        let $;
        (this.fieldName = this.dataset.name),
            (this.input = this.querySelector('[type="text"], [type="number"], textarea')),
            (this.inputRadios = this.querySelectorAll('[type="radio"]')),
            (this.select = this.querySelector(".select__select")),
            (this.productForm = document.getElementById("product-form-" + this.dataset.section)),
            (this.prevValue = this.dataset.defaultValue),
            (this.isRequired = this.dataset.required === "true"),
            (this.isText = true),
            (this.notMain = this.dataset.notMain === "true"),
            (this.dataset.type === "select" || "pills" === this.dataset.type) && (this.isText = false),
            this.createInputs(),
            this.isRequired &&
                this.isText &&
                ((this.isValid = true),
                (this.atcButtons = this.notMain
                    ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section)
                    : document.querySelectorAll(".main-product-atc")),
                (this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section)),
                (this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label")),
                (this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error")),
                (this.atcErrorMsg = this.dataset.atcErrorMsg),
                (this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
                (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
                (this.applyStickyAtcError = "true" === this.dataset.applyStickyAtcError),
                (this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section)),
                this.applyStickyAtcError &&
                    this.stickyAtcButton &&
                    ((this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label")),
                    (this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error")),
                    (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
                this.validateValue(this.prevValue, null)),
            this.input && this.input.addEventListener("input", this.handleChange.bind(this)),
            this.inputRadios.forEach((t) => {
                let e;
                t.addEventListener("input", this.handleChange.bind(this));
            }),
            this.select && this.select.addEventListener("change", this.handleChange.bind(this));
    }
    handleChange($) {
        let t,
            e = $.target.value.trim();
        if ($.target.checkValidity()) this.prevValue = e;
        else {
            $.target.value = this.prevValue;
            return;
        }
        (this.dataset.value = e),
            (this.productFormInput.value = e),
            this.isRequired && this.isText && this.validateValue(e, $.target);
    }
    validateValue($, t) {
        let e,
            x = $.length > 0;
        if (x === this.isValid) return;
        (this.isValid = x),
            t &&
                (this.isValid
                    ? (t.classList.remove("input--error"),
                      (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1))
                    : (t.classList.add("input--error"),
                      (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1)));
        let i = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
            s = "true" === this.mainAtcButton.dataset.unavailable;
        this.atcButtons.forEach(($) => {
            let t;
            i && !s ? $.removeAttribute("disabled") : $.setAttribute("disabled", "");
        }),
            0 !== this.atcErrorMsg.length &&
                (i
                    ? ((this.mainAtcBtnLabel.style.display = ""),
                      (this.mainAtcBtnError.style.display = "none"),
                      this.applyStickyAtcError &&
                          this.stickyAtcButton &&
                          ((this.stickyAtcBtnLabel.style.display = ""), (this.stickyAtcBtnError.style.display = "none")))
                    : ((this.mainAtcBtnLabel.style.display = "none"),
                      (this.mainAtcBtnError.style.display = ""),
                      this.applyStickyAtcError &&
                          this.stickyAtcButton &&
                          ((this.stickyAtcBtnLabel.style.display = "none"), (this.stickyAtcBtnError.style.display = ""))));
    }
    createInputs() {
        let $;
        (this.productFormInput = document.createElement("input")),
            this.productFormInput.setAttribute("type", "hidden"),
            this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"),
            (this.productFormInput.value = this.dataset.defaultValue),
            this.productFormInput.classList.add("flowbit-property-input"),
            this.productForm.appendChild(this.productFormInput);
    }
}
function playMedia() {
    let $;
    serial || (serial = document.currentScript.dataset.animationsType || "");
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
    constructor() {
        let $;
        super(),
            (this.secondarySelectSelector = "StickyAtcVariantPicker-"),
            (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
            (this.isSecondary = false),
            (this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
            (this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true"),
            (this.prependMedia = this.dataset.disablePrepend != "true"),
            (this.filtering = this.dataset.hasFiltering === "true"),
            (this.skipNonExistent = "true" === this.dataset.skipNonExistent),
            (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
            this.hasQuantityBreaksPicker &&
                ((this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle),
                (this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages)),
            this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        let $;
        if (
            (this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(true, "", false),
            this.updatePickupAvailability(),
            this.removeErrorMessage(),
            this.updateVariantStatuses(),
            this.currentVariant)
        ) {
            if (this.skipUnavailable && !this.currentVariant.available && findAvailableVariant(this, this.options, true, true, true))
                return;
            this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
        } else {
            if (
                (this.toggleAddButton(true, "", true),
                this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable))
            )
                return;
            this.setUnavailable();
        }
    }
    updateOptions() {
        let $,
            t = [];
        this.querySelectorAll(".product-form__input").forEach((e) => {
            let x,
                i,
                s = e.querySelector(".product-form__input__type").dataset.type;
            (i = "dropdown" == s || s == "dropdwon" ? e.querySelector(".select__select").value : e.querySelector('input[type="radio"]:checked').value),
                t.push(i);
        }),
            (this.options = t);
    }
    updateMasterId() {
        let $;
        this.currentVariant = this.getVariantData().find((t) => {
            let e;
            return !t.options.map(($, t) => this.options[t] === $).includes(false);
        });
    }
    updateMedia() {
        let $;
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        let t = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + '"]');
        t.forEach((t) =>
            t.setActiveMedia(
                this.dataset.section + "-" + this.currentVariant.featured_media.id,
                this.prependMedia,
                this.filtering,
                this.currentVariant
            )
        );
        let e = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
        if (!e) return;
        let x = e.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
        e.prepend(x);
    }
    updateURL() {
        let $;
        this.currentVariant &&
            this.dataset.updateUrl !== "false" &&
            window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
    }
    updateShareUrl() {
        let $,
            t = document.getElementById("Share-" + this.dataset.section);
        t && t.updateUrl && t.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
    }
    updateVariantInput() {
        let $,
            t = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
        t.forEach((t) => {
            let e,
                x = t.querySelector('input[name="id"]');
            (x.value = this.currentVariant.id), x.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }
    updateVariantStatuses() {
        let $,
            t = this.variantData.filter((t) => this.querySelector(":checked").value === t.option1),
            e;
        (e = this.isSecondary && this.secondarySelect ? [...this.secondarySelect.querySelectorAll(".product-form__input")] : [...this.querySelectorAll(".product-form__input")]).forEach(
            (x, i) => {
                let s;
                if (0 === i) return;
                let a = [...x.querySelectorAll('input[type="radio"], .select__select option')],
                    r = e[i - 1].querySelector(":checked").value,
                    c = t.filter(($) => $.available && $["option" + i] === r).map(($) => $["option" + (i + 1)]),
                    d = t.filter(($) => $["option" + i] === r).map(($) => $["option" + (i + 1)]);
                this.setInputAvailability(a, c, d, this.skipNonExistent, this.skipUnavailable);
            }
        );
    }
    setInputAvailability($, t, e, x = false, i = false) {
        let s;
        $.forEach(($) => {
            let a;
            $.classList.remove("unavailable", "non-existent", "disabled"), $.removeAttribute("disabled"), $.removeAttribute("hidden");
            let r = $.getAttribute("value"),
                c = null;
            $.dataset.swatch === "true" && (c = $.closest(".color-swatch")),
                c && c.classList.remove("unavailable", "non-existent", "disabled"),
                e.includes(r)
                    ? t.includes(r)
                        ? "OPTION" === $.nodeName
                            ? ($.innerText = r)
                            : ($.classList.remove("disabled"), c && c.classList.remove("disabled"))
                        : $.nodeName === "OPTION"
                          ? (($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r)),
                            $.classList.add("unavailable"),
                            i && ($.setAttribute("disabled", ""), $.setAttribute("hidden", "")))
                          : ($.classList.add("disabled", "unavailable"), c && c.classList.add("disabled", "unavailable"))
                    : $.nodeName === "OPTION"
                      ? (($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r)),
                        $.classList.add("non-existent"),
                        x && ($.setAttribute("disabled", ""), $.setAttribute("hidden", "")))
                      : ($.classList.add("disabled", "non-existent"), c && c.classList.add("disabled", "non-existent"));
        });
    }
    updatePickupAvailability() {
        let $,
            t = document.querySelector("pickup-availability");
        t &&
            (this.currentVariant && this.currentVariant.available
                ? t.fetchAvailability && t.fetchAvailability(this.currentVariant.id)
                : (t.removeAttribute("available"), (t.innerHTML = "")));
    }
    removeErrorMessage() {
        let $,
            t = this.closest("section");
        if (!t) return;
        let e = t.querySelector("product-form");
        e && e.handleErrorMessage();
    }
    renderProductInfo() {
        let $,
            t = this.currentVariant.id,
            e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(
            this.dataset.url +
                "?variant=" +
                t +
                "&section_id=" +
                (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
        )
            .then((t) => t.text())
            .then((x) => {
                let i;
                if (this.currentVariant.id !== t) return;
                let s = new DOMParser().parseFromString(x, "text/html"),
                    a = document.getElementById("price-" + this.dataset.section),
                    r = s.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
                    c = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
                    d = s.getElementById(
                        "sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                    ),
                    n = document.getElementById("sticky-atc-price-" + this.dataset.section),
                    l = s.getElementById(
                        "sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                    ),
                    h = document.getElementById("sticky-atc-image-" + this.dataset.section);
                h && this.currentVariant.featured_image && (h.src = this.currentVariant.featured_image.src);
                let o = document.getElementById("main-atc-price-" + this.dataset.section),
                    u = s.getElementById(
                        "main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                    ),
                    f = document.querySelectorAll('[id^="custom-label-' + this.dataset.section + '"]'),
                    _ = s.querySelectorAll(
                        '[id^="custom-label-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '"]'
                    ),
                    p = s.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
                    b = document.getElementById("Sku-" + this.dataset.section),
                    m = s.getElementById(
                        "Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                    ),
                    y = document.getElementById("Inventory-" + this.dataset.section);
                if (
                    (a && r && (a.innerHTML = r.innerHTML),
                    c && d && (c.innerHTML = d.innerHTML),
                    n && l && (n.innerHTML = l.innerHTML),
                    u && o && (o.innerHTML = u.innerHTML),
                    f && _)
                )
                    for (var g = 0; g < f.length; g++) f[g].innerHTML = _[g].innerHTML;
                if (
                    (m && y && (y.innerHTML = m.innerHTML),
                    p && b && ((b.innerHTML = p.innerHTML), b.classList.toggle("visibility-hidden", p.classList.contains("visibility-hidden"))),
                    this.QuantityBreaks)
                ) {
                    let v = s.getElementById(
                            "quantity-breaks-" +
                                (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                        ),
                        S = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
                        k = v.querySelectorAll(".dynamic-price");
                    for (let I = 0; I < S.length; I++) S[I].innerHTML = k[I].innerHTML;
                    if (this.QuantityBreaks.hasVariants) {
                        this.QuantityBreaks.variantSelects.forEach(($) => {
                            let t;
                            $.dataset.selectedId = this.currentVariant.id;
                        });
                        let q = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
                            C = v.querySelectorAll(".quantity-break__variant-select");
                        for (let E = 0; E < q.length; E++) q[E].innerHTML = C[E].innerHTML;
                        this.QuantityBreaks.initVariants();
                    }
                    this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(($) => {
                        let t;
                        $.src = this.currentVariant.featured_image.src;
                    }),
                        this.QuantityBreaks.dataset.updatePdpPrices === "true" &&
                            ((this.QuantityBreaks.dataset.basePrice = v.dataset.basePrice),
                            this.QuantityBreaks.labels.forEach(($) => {
                                let t;
                                $.dataset.baseComparePrice = v.querySelector('label[data-input="' + $.dataset.input + '"]').dataset.baseComparePrice;
                            }),
                            this.QuantityBreaks.initOfferPrices());
                }
                if (this.hasQuantityBreaksPicker) {
                    let w = s.getElementById(
                            "variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                        ),
                        B = this.querySelectorAll(".dynamic-price"),
                        T = w.querySelectorAll(".dynamic-price");
                    for (let A = 0; A < B.length; A++) B[A].innerHTML = T[A].innerHTML;
                    if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
                        let P = this.querySelectorAll(".quantity-break__image img"),
                            L = w.querySelectorAll(".quantity-break__image img");
                        for (let D = 0; D < P.length; D++) P[D].src = L[D].src;
                    }
                }
                if (this.secondarySelect) {
                    let F = s.getElementById(
                        "" +
                            this.secondarySelectSelector +
                            (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)
                    );
                    F && (this.secondarySelect.innerHTML = F.innerHTML);
                }
                let M = document.getElementById("price-" + this.dataset.section);
                M && M.classList.remove("visibility-hidden"),
                    (this.dataset.options = this.currentVariant.options.join(",")),
                    y && y.classList.toggle("visibility-hidden", "" === m.innerText);
                let U = s.getElementById("ProductSubmitButton-" + e);
                this.toggleAddButton(!U || U.hasAttribute("disabled"), window.variantStrings.soldOut),
                    publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: e, html: s, variant: this.currentVariant } });
            });
    }
    toggleAddButton($ = true, t, e = true) {
        let x,
            i = document.getElementById("product-form-" + this.dataset.section);
        if (!i) return;
        let s = i.querySelector('[name="add"]');
        if (!s) return;
        let a = document.querySelectorAll(".main-product-atc");
        var r = i.querySelector(".main-atc__label__text");
        r || (r = i.querySelector(".main-atc__label"));
        let c = i.querySelector(".main-atc-price"),
            d = document.querySelector(".sticky-atc__add_button"),
            n = null,
            l = null;
        if ((d && ((n = d.querySelector(".sticky-atc__label__text")), (l = d.querySelector(".sticky-atc__button-price"))), $))
            s.setAttribute("disabled", "disabled"),
                s.setAttribute("data-unavailable", "true"),
                t && r && (r.textContent = t),
                n && d.dataset.label && (n.textContent = t),
                a.forEach(($) => {
                    let t;
                    $.setAttribute("disabled", "disabled");
                }),
                c && c.classList.add("hidden"),
                l && l.classList.add("hidden");
        else {
            s.setAttribute("data-unavailable", "false");
            let h = s.dataset.customLabel ?? window.variantStrings.addToCart;
            r && (r.textContent = h),
                c && c.classList.remove("hidden"),
                n && d.dataset.label && (n.textContent = d.dataset.label),
                l && l.classList.remove("hidden"),
                s.dataset.requiredFields === s.dataset.validFields &&
                    (s.removeAttribute("disabled"),
                    a.forEach(($) => {
                        $.removeAttribute("disabled");
                    }));
        }
        if (!e) return;
    }
    setUnavailable() {
        let $,
            t = document.getElementById("product-form-" + this.dataset.section);
        if (!t) return;
        let e = t.querySelector('[name="add"]');
        var x = t.querySelector(".main-atc__label__text");
        x || (x = t.querySelector(".main-atc__label"));
        let i = document.getElementById("price-" + this.dataset.section),
            s = document.getElementById("Inventory-" + this.dataset.section),
            a = document.getElementById("Sku-" + this.dataset.section);
        e &&
            (x && (x.textContent = window.variantStrings.unavailable),
            i && i.classList.add("visibility-hidden"),
            s && s.classList.add("visibility-hidden"),
            a && a.classList.add("visibility-hidden"));
    }
    getVariantData() {
        let $;
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
    constructor() {
        let $;
        super(),
            (this.secondarySelectSelector = "variant-selects-"),
            (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
            (this.isSecondary = true);
    }
    updateOptions() {
        let $;
        this.options = this.querySelector("select").value.split(",");
    }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
    constructor() {
        let $;
        super(),
            (this.secondarySelectSelector = "variant-selects-"),
            (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
            (this.isSecondary = true);
    }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
    constructor() {
        let $;
        super(), (this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit"));
    }
    onVariantChange() {
        let $;
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(true, "", false),
            this.updateVariantStatuses(),
            this.currentVariant
                ? (this.updateMedia(),
                  this.updateVariantInput(),
                  this.updateQuickAddUrl(),
                  this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut))
                : (this.toggleAddButton(true, "", true), this.setUnavailable());
    }
    updateMedia() {
        let $;
        if (!this.currentVariant || !this.currentVariant.featured_media) return;
        let t = document.getElementById(this.dataset.section + "-image");
        if (!t) return;
        let e = this.currentVariant.featured_media.preview_image,
            x = e.src.split("?")[0],
            i = [165, 360, 533, 720, 940, 1066]
                .filter((t) => e.width >= t)
                .map((t) => x + "?width=" + t + " " + t + "w")
                .join(", ");
        (t.srcset = i + ", " + x + " " + e.width + "w"), (t.src = x + "?width=533");
    }
    updateQuickAddUrl() {
        let $;
        this.currentVariant &&
            this.quickAddSubmit &&
            (this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id);
    }
}
customElements.define("card-variant-selects", CardVariantSelects);
